<template>
  <div>
    <div v-if="loading">
      <loader></loader>
    </div>
    <div id="canvas">
      <img class="previous-page" src="../../img/left.svg" value="previous" @click="pagePrev" />
      <img class="next-page" src="../../img/right.svg" value="next" @click="pageNext" />
      <div class="flipbook-viewport">
        <div class="col-auto float-left bar">
          <router-link style="padding-right:90px" to="/home">Kiosk</router-link>
          <a to v-if="!index" @click="cambiarEstado('/index')">Index</a>
          <a to="/index" v-else @click="cambiarEstado('')">Close</a>
        </div>
        <div class="col-auto float-right">
          <a class="zoom-icon zoom-icon-in">Fullscreen</a>
        </div>
        <div class="container" @click="pause">
          <div class="flipbook" id="btnClick" @keyup.right="pause" @keyup.left="pause" @mousedown="pause"
            @click="pause">
            <div v-if="seeCover == 'cover11-1'":style="'background-image:url(https://firebasestorage.googleapis.com/v0/b/mission-magazine-fb409.appspot.com/o/issue-11%2FCover1_issue11_OFC_Aweng.png?alt=media&token=19c7f8da-1b65-4030-8620-da70930f40db)'"></div>           
            <div v-else-if="seeCover == 'cover11-2'" :style="'background-image:url(https://firebasestorage.googleapis.com/v0/b/mission-magazine-fb409.appspot.com/o/issue-11%2FCover2_issue11_OFC_Georgia.png?alt=media&token=16f51276-a919-43d3-adbc-e48532e2bc54)'"></div>   
            <div v-else-if="seeCover == 'cover11-3'" :style="'background-image:url(https://firebasestorage.googleapis.com/v0/b/mission-magazine-fb409.appspot.com/o/issue-11%2FCover3_issue11_OFC_Alex.png?alt=media&token=47accb2d-c74a-41df-9074-3f35d3b4369a)'"></div>  
            <div v-else :style="'background-image:url(https://firebasestorage.googleapis.com/v0/b/mission-magazine-fb409.appspot.com/o/issue-11%2FCover1_issue11_OFC_Aweng.png?alt=media&token=19c7f8da-1b65-4030-8620-da70930f40db)'"></div>           
           
            <div :style="'background-image:url(' + pages11[0] + ')'"></div>
            <div :style="'background-image:url(' + pages11[1] + ')'"></div>
            <div :style="'background-image:url(' + pages11[2] + ')'"></div>
            <div :style="'background-image:url(' + pages11[3] + ')'"></div>
            <div :style="'background-image:url(' + pages11[4] + ')'"></div>
            <div :style="'background-image:url(' + pages11[5] + ')'"></div>
            <div :style="'background-image:url(' + pages11[6] + ')'"></div>
            <div :style="'background-image:url(' + pages11[7] + ')'"></div>
            <div :style="'background-image:url(' + pages11[8] + ')'"></div>
            <div :style="'background-image:url(' + pages11[9] + ')'"></div>
            <div :style="'background-image:url(' + pages11[10] + ')'"></div>
            <div :style="'background-image:url(' + pages11[11] + ')'"></div>
            <div :style="'background-image:url(' + pages11[12] + ')'"></div>
            <div :style="'background-image:url(' + pages11[13] + ')'"></div>
            <div :style="'background-image:url(' + pages11[14] + ')'"></div>
            <div :style="'background-image:url(' + pages11[15] + ')'"></div>
            <div :style="'background-image:url(' + pages11[16] + ')'"></div>
            <div :style="'background-image:url(' + pages11[17] + ')'"></div>
            <div :style="'background-image:url(' + pages11[18] + ')'"></div>
            <div :style="'background-image:url(' + pages11[19] + ')'"></div>
            <div :style="'background-image:url(' + pages11[20] + ')'"></div>
            <div :style="'background-image:url(' + pages11[21] + ')'"></div>
            <div :style="'background-image:url(' + pages11[22] + ')'"></div>
            <div :style="'background-image:url(' + pages11[23] + ')'"></div>
            <div :style="'background-image:url(' + pages11[24] + ')'"></div>
            <div :style="'background-image:url(' + pages11[25] + ')'"></div>
            <div :style="'background-image:url(' + pages11[26] + ')'"></div>
            <div :style="'background-image:url(' + pages11[27] + ')'"></div>
            <div :style="'background-image:url(' + pages11[28] + ')'"></div>
            <div :style="'background-image:url(' + pages11[29] + ')'"></div>
            <div :style="'background-image:url(' + pages11[30] + ')'"></div>
            <div :style="'background-image:url(' + pages11[31] + ')'"></div>
            <!-- Eco Edits -->
            <div :style="'background-image:url(' + pages11[32] + ')'">
              <a class="minilinks articles2" style="top:26.8%; left:38.8%; width: 7%" target="_blank"
                @click="openLink('https://www.ganni.com/us/home')">GANNI</a>
              <a class="minilinks articles2" style="top:18%; right:10%; width: 7%" target="_blank"
                @click="openLink('https://www.sezane.com/us')">SEZANE</a>
              <a class="minilinks articles2" style="bottom:23%; right:8.3%; width: 10%" target="_blank"
                @click="openLink('https://us-store.isseymiyake.com/')">ISSEY MIYAKE</a>
              <a class="minilinks articles2" style="bottom:5.5%; right:8.8%; width: 14%" target="_blank"
                @click="openLink('https://shop.cleanwaves.com/')">CLEAN WAVES</a>
              <a class="minilinks articles2" style="bottom:30%; right:24.2%; width: 12.6%" target="_blank"
                @click="openLink('https://mozhdehmatin.com/')">MOZHDEH MATIN</a>
              <a class="minilinks articles2" style="bottom:40.4%; right:34%; width: 10.2%" target="_blank"
                @click="openLink('https://operasport.net/')">OPERA SPORT</a>
              <a class="minilinks articles2" style="bottom:43.8%; left:18%; width: 10.2%" target="_blank"
                @click="openLink('https://operasport.net/')">OPERA SPORT</a>
              <a class="minilinks articles2" style="bottom:28.2%; left:34.5%; width: 11.8%" target="_blank"
                @click="openLink('https://www.saltandstone.com/')">SALT AND STONE</a>
              <a class="minilinks articles2" style="bottom:5.5%; left:35%; width: 6.5%" target="_blank"
                @click="openLink('https://www.asket.com/us')">ASKET</a>
            </div>
            <!---------------------------------------------------------- -->
            <div :style="'background-image:url(' + pages11[33] + ')'">
              <a class="minilinks articles2" style="top:14.6%; right:44%; width: 10.5%" target="_blank"
                @click="openLink('https://us.stinegoya.com/')">STINE GOYA</a>
              <a class="minilinks articles2" style="top:53%; right:40.8%; width: 14%" target="_blank"
                @click="openLink('https://www.raeburndesign.co.uk/')">RÁEBURN</a>
              <a class="minilinks articles2" style="top:16.4%; right:17.8%; width: 9%" target="_blank"
                @click="openLink('https://kjaerweis.com/')">KAJER WEIS</a>
              <a class="minilinks articles2" style="bottom:30%; right:28.6%; width: 10%" target="_blank"
                @click="openLink('https://www.violettefr.com/products/yeux-paint')">VIOLETTE FR</a>
              <a class="minilinks articles2" style="bottom:42.2%; right:10%; width: 13.4%" target="_blank"
                @click="openLink('https://www.stellamccartney.com/us/en/')">STELLA MCCARTNEY</a>
              <a class="minilinks articles2" style="bottom:5.5%; right:27.8%; width: 15%" target="_blank"
                @click="openLink('https://zeromariacornejo.com/')">ZERO + MARIA CORNEJO</a>
              <a class="minilinks articles2" style="bottom:31.8%; left:42.2%; width: 11.5%" target="_blank"
                @click="openLink('https://notobotanics.com/')">NOTO</a>
              <a class="minilinks articles2" style="bottom:17.8%; left:33.5%; width: 9.2%" target="_blank"
                @click="openLink('https://operasport.net/')">OPERA SPORT</a>
              <a class="minilinks articles2" style="bottom:5.5%; left:25%; width: 8.8%" target="_blank"
                @click="openLink('https://untag.com/')">UNTAG</a>
              <a class="minilinks articles2" style="bottom:44%; left:12.5%; width: 9.2%" target="_blank"
                @click="openLink('https://www.sayebrand.com/')">SAYE</a>
              <a class="minilinks articles2" style="top:30.4%; left:12.5%; width: 7.8%" target="_blank"
                @click="openLink('https://gomi.design/')">GOMI </a>

            </div>
            <!-- End Eco Edits -->
            <div :style="'background-image:url(' + pages11[34] + ')'"></div>
            <div :style="'background-image:url(' + pages11[35] + ')'"> </div>
            <div :style="'background-image:url(' + pages11[36] + ')'">
              <a class="links articles2" style="bottom:4.7%; right:36.6%; width: 13%" target="_blank"
                @click="openLink('https://www.instagram.com/whois.grayson/?locale=en')">@Grayson Mcferrin-Hogan</a>
            </div>
            <div :style="'background-image:url(' + pages11[37] + ')'"></div>
            <div :style="'background-image:url(' + pages11[38] + ')'"></div>
            <div :style="'background-image:url(' + pages11[39] + ')'"></div>
            <div :style="'background-image:url(' + pages11[40] + ')'"></div>
            <div :style="'background-image:url(' + pages11[41] + ')'">
              <div class="video01">
                <vue-player ref="video1" id="video01"
                  src="https://firebasestorage.googleapis.com/v0/b/mission-magazine-fb409.appspot.com/o/issue-11%2Fmedia%2Fpg041_MAISON_MARGILA_ARTISANAL.m4v?alt=media&token=e7c6b2fe-2664-4399-aa36-f7b0b16a766d"></vue-player>
              </div>
              <a class="minilinks articles2" style="bottom: 49.5%; left: 5%; width: 8%; "
                @click.prevent="playVideo01">Click to Play</a>
                
              <a class="links articles2" style="bottom:4.6%; right:39%; width: 10%" target="_blank"
                @click="openLink('https://www.instagram.com/thisisluckylove/?hl=en')">@whois.grayson</a>
            
            </div>
            <div :style="'background-image:url(' + pages11[42] + ')'"></div>
            <div :style="'background-image:url(' + pages11[43] + ')'"></div>
            <div :style="'background-image:url(' + pages11[44] + ')'"></div>
            <div :style="'background-image:url(' + pages11[45] + ')'"></div>
            <div :style="'background-image:url(' + pages11[46] + ')'"></div>
            <div :style="'background-image:url(' + pages11[47] + ')'">
              <a class="links articles2" style="bottom:4.6%; left:50.8%; width: 10.5%" target="_blank"
                @click="openLink('https://www.instagram.com/serpentwithfeet/?hl=en')">@serpentwithfeet</a>
            </div>
            <div :style="'background-image:url(' + pages11[48] + ')'"></div>
            <div :style="'background-image:url(' + pages11[49] + ')'"></div>
            <div :style="'background-image:url(' + pages11[50] + ')'"></div>
            <div :style="'background-image:url(' + pages11[51] + ')'"></div>
            <div :style="'background-image:url(' + pages11[52] + ')'"></div>
            <div :style="'background-image:url(' + pages11[53] + ')'">
              <a class="links articles2" style="bottom:4.6%; left:50.8%; width: 10.5%" target="_blank"
                @click="openLink('https://www.toritsui.com')">@toritsui </a>
            </div>
            <div :style="'background-image:url(' + pages11[54] + ')'">
              <a class="links articles2" style="bottom:4.2%; left:50.4%; width: 15%" target="_blank"
                @click="openLink('https://www.instagram.com/harleighawalker/?hl=en')">@harleighawalker</a>
            </div>
            <div :style="'background-image:url(' + pages11[55] + ')'"></div>
            <div :style="'background-image:url(' + pages11[56] + ')'"></div>
            <div :style="'background-image:url(' + pages11[57] + ')'"></div>
            <div :style="'background-image:url(' + pages11[58] + ')'"></div>
            <div :style="'background-image:url(' + pages11[59] + ')'">
              <a class="links articles2" style="bottom:4.7%; left:50.8%; width: 6.5%" target="_blank"
                @click="openLink('https://www.instagram.com/vorphan/?hl=en')">@vorphan</a>
            </div>
            <div :style="'background-image:url(' + pages11[60] + ')'"></div>
            <div :style="'background-image:url(' + pages11[61] + ')'"></div>
            <div :style="'background-image:url(' + pages11[62] + ')'">
              <a class="links articles2" style="bottom:15.5%; left:26.8%; width: 24.6%" target="_blank"
                @click="openLink('https://www.instagram.com/costabrazil/?hl=en')">@costabrazil</a>
            </div>
            <div :style="'background-image:url(' + pages11[63] + ')'"></div>
            <div :style="'background-image:url(' + pages11[64] + ')'">
              <a class="links articles2" style="bottom:17%; left:14.8%; width: 38%" target="_blank"
                @click="openLink('https://www.instagram.com/anothertomorrow/?hl=en')">@anothertomorrow</a>
            </div>
            <div :style="'background-image:url(' + pages11[65] + ')'"></div>
            <div :style="'background-image:url(' + pages11[66] + ')'">
              <a class="links articles2" style="bottom:15.2%; left:22.4%; width: 31.5%" target="_blank"
                @click="openLink('https://www.instagram.com/emporioarmani/?hl=en')">@emporioarmani</a>
            </div>
            <div :style="'background-image:url(' + pages11[67] + ')'"></div>
            <div :style="'background-image:url(' + pages11[68] + ')'">
              <a class="links articles2" style="bottom:12.4%; right:20.5%; width: 35.5%" target="_blank"
                @click="openLink('https://www.instagram.com/viviennewestwood/?hl=en')">@vivennewestwood</a>
            </div>
            <div :style="'background-image:url(' + pages11[69] + ')'"></div>
            <div :style="'background-image:url(' + pages11[70] + ')'">
              <a class="links articles2" style="bottom:16.8%; right:35.5%; width: 34%" target="_blank"
                @click="openLink('https://www.instagram.com/stellamccartney/?hl=en')">@stellamccartney</a>
            </div>
            <div :style="'background-image:url(' + pages11[71] + ')'"></div>
            <div :style="'background-image:url(' + pages11[72] + ')'"></div>
            <div :style="'background-image:url(' + pages11[73] + ')'"></div>
            <div :style="'background-image:url(' + pages11[74] + ')'"></div>
            <div :style="'background-image:url(' + pages11[75] + ')'"></div>
            <div :style="'background-image:url(' + pages11[76] + ')'"></div>
            <div :style="'background-image:url(' + pages11[77] + ')'">
              <a class="links articles2" style="bottom:4.6%; left:51%; width: 9%" target="_blank"
                @click="openLink('https://www.instagram.com/genamarvin/?hl=en')">@genamarvin</a>
            </div>
            <div :style="'background-image:url(' + pages11[78] + ')'"></div>
            <div :style="'background-image:url(' + pages11[79] + ')'"></div>
            <div :style="'background-image:url(' + pages11[80] + ')'"></div>
            <div :style="'background-image:url(' + pages11[81] + ')'"></div>
            <div :style="'background-image:url(' + pages11[82] + ')'"></div>
            <div :style="'background-image:url(' + pages11[83] + ')'"></div>
            <div :style="'background-image:url(' + pages11[84] + ')'">
              <a class="links articles2" style="bottom:4.6%; left:50.8%; width: 5.5%" target="_blank"
                @click="openLink('https://www.instagram.com/chiosse/?hl=en')">@chiosse</a>
            </div>
            <div :style="'background-image:url(' + pages11[85] + ')'"></div>
            <div :style="'background-image:url(' + pages11[86] + ')'"></div>
            <div :style="'background-image:url(' + pages11[87] + ')'"></div>
            <div :style="'background-image:url(' + pages11[88] + ')'"></div>
            <div :style="'background-image:url(' + pages11[89] + ')'"></div>
            <div :style="'background-image:url(' + pages11[90] + ')'"></div>
            <div :style="'background-image:url(' + pages11[91] + ')'"></div>
            <div :style="'background-image:url(' + pages11[92] + ')'"></div>
            <div :style="'background-image:url(' + pages11[93] + ')'">
              <a class="links articles2" style="bottom:4.6%; left:50.8%; width: 9.5%" target="_blank"
                @click="openLink('https://www.instagram.com/aaron___philip/?hl=en')">@aaron_philip</a>
            </div>
            <div :style="'background-image:url(' + pages11[94] + ')'"></div>
            <div :style="'background-image:url(' + pages11[95] + ')'"></div>
            <div :style="'background-image:url(' + pages11[96] + ')'"></div>
            <div :style="'background-image:url(' + pages11[97] + ')'"></div>
            <div :style="'background-image:url(' + pages11[98] + ')'"></div>
            <div :style="'background-image:url(' + pages11[99] + ')'"></div>
            <div :style="'background-image:url(' + pages11[100] + ')'"></div>
            <div :style="'background-image:url(' + pages11[101] + ')'"></div>
            <div :style="'background-image:url(' + pages11[102] + ')'"></div>
            <div :style="'background-image:url(' + pages11[103] + ')'"></div>
            <div :style="'background-image:url(' + pages11[104] + ')'"></div>
            <div :style="'background-image:url(' + pages11[105] + ')'">
              <a class="minilinks articles2" style="bottom:8%; left:51%; width: 13%" target="_blank"
                @click="openLink('https://www.instagram.com/burberry_daniel.lee/?hl=en')">@burberry_daniel.lee</a>

              <a class="minilinks articles2" style="bottom:6.4%; left:51%; width: 8%" target="_blank"
                @click="openLink('https://www.instagram.com/mrkimjones/?hl=en')">@mrkimjones</a>

              <a class="minilinks articles2" style="bottom:4.6%; left:51%; width: 12%" target="_blank"
                @click="openLink('https://www.instagram.com/donatella_versace/?hl=en')">@donatella_versace</a>
            </div>
            <div :style="'background-image:url(' + pages11[106] + ')'"></div>
            <div :style="'background-image:url(' + pages11[107] + ')'"></div>
            <div :style="'background-image:url(' + pages11[108] + ')'"></div>
            <div :style="'background-image:url(' + pages11[109] + ')'"></div>
            <div :style="'background-image:url(' + pages11[110] + ')'"></div>
            <div :style="'background-image:url(' + pages11[111] + ')'"></div>
            <div :style="'background-image:url(' + pages11[112] + ')'"></div>
            <div :style="'background-image:url(' + pages11[113] + ')'">
              <a class="links articles2" style="bottom:4.6%; left:50.8%; width: 8.5%" target="_blank"
                @click="openLink('https://www.instagram.com/weakkcoffee/?hl=en')">@weakkcoffee</a>
            </div>
            <div :style="'background-image:url(' + pages11[114] + ')'"></div>
            <div :style="'background-image:url(' + pages11[115] + ')'"></div>
            <div :style="'background-image:url(' + pages11[116] + ')'"></div>
            <div :style="'background-image:url(' + pages11[117] + ')'"></div>
            <div :style="'background-image:url(' + pages11[118] + ')'"></div>
            <div :style="'background-image:url(' + pages11[119] + ')'"></div>
            <div :style="'background-image:url(' + pages11[120] + ')'"></div>
            <div :style="'background-image:url(' + pages11[121] + ')'">
              <a class="links articles2" style="bottom:4.6%; left:50.8%; width: 10.5%" target="_blank"
                @click="openLink('https://www.instagram.com/samueldesaboia/?hl=en')">@samueldesaboia</a>
            </div>
            <div :style="'background-image:url(' + pages11[122] + ')'"></div>
            <div :style="'background-image:url(' + pages11[123] + ')'"></div>
            <div :style="'background-image:url(' + pages11[124] + ')'"></div>
            <div :style="'background-image:url(' + pages11[125] + ')'"></div>
            <div :style="'background-image:url(' + pages11[126] + ')'"></div>
            <div :style="'background-image:url(' + pages11[127] + ')'"></div>
            <div :style="'background-image:url(' + pages11[128] + ')'"></div>
            <div :style="'background-image:url(' + pages11[129] + ')'"></div>
            <div :style="'background-image:url(' + pages11[130] + ')'"></div>
            <div :style="'background-image:url(' + pages11[131] + ')'"></div>
            <div :style="'background-image:url(' + pages11[132] + ')'"></div>
            <div :style="'background-image:url(' + pages11[133] + ')'"></div>
            <div :style="'background-image:url(' + pages11[134] + ')'"></div>
            <div :style="'background-image:url(' + pages11[135] + ')'">
              <a class="links articles2" style="bottom:4.6%; left:50.8%; width: 12%" target="_blank"
              @click="openLink('https://www.instagram.com/donatella_versace/?hl=en')">@donatella_versace </a>
            </div>
            <div :style="'background-image:url(' + pages11[136] + ')'"></div>
            <div :style="'background-image:url(' + pages11[137] + ')'">
              <a class="links articles2" style="top:24.4%; left:50.8%; width: 14% " target="_blank"
                @click="openLink('https://www.instagram.com/libbygonzalestx/?hl=en')">@libbygonzalestx</a>
            </div>
            <div :style="'background-image:url(' + pages11[138] + ')'"></div>
            <div :style="'background-image:url(' + pages11[139] + ')'"></div>
            <div :style="'background-image:url(' + pages11[140] + ')'">
              <a class="minilinks articles2" style="bottom:5.4%; left:13.5%; width: 3.4%" target="_blank"
                @click="openLink('https://www.versace.com/us/en/')">@donatella_versace</a>
              </div>
            <div :style="'background-image:url(' + pages11[141] + ')'"></div>
            <div :style="'background-image:url(' + pages11[142] + ')'"></div>
            <div :style="'background-image:url(' + pages11[143] + ')'">
              <a class="links articles2" style="bottom:4.6%; left:50.8%; width: 8.5% " target="_blank"
                @click="openLink('https://www.instagram.com/alexconsani/?hl=en')">@alexconsani</a>
            </div>
            <div :style="'background-image:url(' + pages11[144] + ')'"><a class="minilinks articles2" style="bottom:21.4%; left:7.5%; width: 3.4%" target="_blank"
                @click="openLink('https://www.versace.com/us/en/')">versace</a></div>
            <div :style="'background-image:url(' + pages11[145] + ')'">
              <a class="minilinks articles2" style="bottom:5.3%; right:4%; width: 3.4%" target="_blank"
                @click="openLink('https://www.versace.com/us/en/')">versace</a>
              </div>
            <div :style="'background-image:url(' + pages11[146] + ')'">
              <a class="minilinks articles2" style="bottom:5.4%; left:9.5%; width: 3.4%" target="_blank"
                @click="openLink('https://www.versace.com/us/en/')">versace</a>
            </div>
            <div :style="'background-image:url(' + pages11[147] + ')'">
              <a class="minilinks articles2" style="bottom:5.3%; right:4%; width: 3.4%" target="_blank"
                @click="openLink('https://www.versace.com/us/en/')">versace</a>
            </div>
            <div :style="'background-image:url(' + pages11[148] + ')'"></div>
            <div :style="'background-image:url(' + pages11[149] + ')'">
              <a class="minilinks articles2" style="bottom:5.3%; right:4%; width: 3.4%" target="_blank"
                @click="openLink('https://www.versace.com/us/en/')">versace</a>
            </div>
            <div :style="'background-image:url(' + pages11[150] + ')'"></div>
            <div :style="'background-image:url(' + pages11[151] + ')'">
              <a class="minilinks articles2" style="bottom:4.6%; left:50.8%; width: 8.5% " target="_blank"
                @click="openLink('https://www.instagram.com/awengchuol/?hl=en')">@awengchuol</a>
            </div>
            <div :style="'background-image:url(' + pages11[152] + ')'"></div>
            <div :style="'background-image:url(' + pages11[153] + ')'">
              <a class="minilinks articles2" style="bottom:8.2%; right:4%; width: 3.4%" target="_blank"
                @click="openLink('https://www.versace.com/us/en/')">versace</a>
                <a class="minilinks articles2" style="bottom:5.3%; right:4%; width: 3.4%" target="_blank"
                @click="openLink('https://www.versace.com/us/en/')">versace</a>
            </div>
            <div :style="'background-image:url(' + pages11[154] + ')'"><a class="minilinks articles2" style="bottom:5.4%; left:9%; width: 3.4%" target="_blank"
                @click="openLink('https://www.versace.com/us/en/')">versace</a></div>
            <div :style="'background-image:url(' + pages11[155] + ')'">
              <a class="minilinks articles2" style="bottom:5.3%; right:4%; width: 3.4%" target="_blank"
                @click="openLink('https://www.versace.com/us/en/')">versace</a>
            </div>
            <div :style="'background-image:url(' + pages11[156] + ')'"><a class="minilinks articles2" style="bottom:5.4%; left:5.5%; width: 3.4%" target="_blank"
                @click="openLink('https://www.versace.com/us/en/')">versace</a></div>
            <div :style="'background-image:url(' + pages11[157] + ')'"></div>
            <div :style="'background-image:url(' + pages11[158] + ')'"></div>
            <div :style="'background-image:url(' + pages11[159] + ')'">
              <a class="minilinks articles2" style="bottom:4.6%; left:50.8%; width: 9.5% " target="_blank"
                @click="openLink('https://www.instagram.com/georgiapalmer/?hl=en')">@georgiapalmer</a>
            </div>
            <div :style="'background-image:url(' + pages11[160] + ')'"></div>
            <div :style="'background-image:url(' + pages11[161] + ')'"> <a class="minilinks articles2" style="bottom:5.3%; right:4%; width: 3.4%" target="_blank"
                @click="openLink('https://www.versace.com/us/en/')">versace</a></div>
            <div :style="'background-image:url(' + pages11[162] + ')'"></div>
            <div :style="'background-image:url(' + pages11[163] + ')'"></div>
            <div :style="'background-image:url(' + pages11[164] + ')'"></div>
            <div :style="'background-image:url(' + pages11[165] + ')'"></div>
            <div :style="'background-image:url(' + pages11[166] + ')'"></div>
            <div :style="'background-image:url(' + pages11[167] + ')'"></div>
            <div :style="'background-image:url(' + pages11[168] + ')'"></div>
            <div :style="'background-image:url(' + pages11[169] + ')'">
              <a class="minilinks articles2" style="bottom:4.6%; left:50.8%; width: 11.5% " target="_blank"
                @click="openLink('https://www.instagram.com/chrissychlapecka/?hl=en')">@chrissychlapecka</a>
            </div>
            <div :style="'background-image:url(' + pages11[170] + ')'">
              <a class="minilinks articles2" style="bottom:4.6%; left:50.8%; width: 10% " target="_blank"
                @click="openLink('https://www.instagram.com/logibrowni/?hl=en')">@logibrown</a>
            </div>
            <div :style="'background-image:url(' + pages11[171] + ')'"></div>
            <div :style="'background-image:url(' + pages11[172] + ')'"></div>
            <div :style="'background-image:url(' + pages11[173] + ')'"></div>
            <div :style="'background-image:url(' + pages11[174] + ')'"></div>
            <div :style="'background-image:url(' + pages11[175] + ')'">
              <a class="minilinks articles2" style="bottom:4.6%; left:50.8%; width: 10% " target="_blank"
                @click="openLink('https://www.instagram.com/raquel_willis/?hl=en')">@raquel_willis</a>
            </div>
            <div :style="'background-image:url(' + pages11[176] + ')'"></div>
            <div :style="'background-image:url(' + pages11[177] + ')'"></div>
            <div :style="'background-image:url(' + pages11[178] + ')'"></div>
            <div :style="'background-image:url(' + pages11[179] + ')'"></div>
            <div :style="'background-image:url(' + pages11[180] + ')'"></div>
            <div :style="'background-image:url(' + pages11[181] + ')'">
              <a class="minilinks articles2" style="bottom:4.6%; left:50.8%; width: 9.5% " target="_blank"
                @click="openLink('https://www.instagram.com/imara_jones_/?hl=en')">@Imara_jones_</a>
            </div>
            <div :style="'background-image:url(' + pages11[182] + ')'"></div>
            <div :style="'background-image:url(' + pages11[183] + ')'">
              <a class="minilinks articles2" style="top:17.6%; left:52%; width: 12.5% " target="_blank"
                @click="openLink('https://www.instagram.com/mayathepsychc/?hl=en')">@mayathepsychc</a>
            </div>
            <div :style="'background-image:url(' + pages11[184] + ')'"></div>
            <div :style="'background-image:url(' + pages11[185] + ')'">
              <a
                class="links articles2"
                style="bottom: 5%;left:30%; width: 39.5%"
                target="_blank"
                @click="openBook"
              >CLICK HERE TO DOWNLOAD</a></div>
            <div :style="'background-image:url(' + pages11[186] + ')'"></div>
            <div :style="'background-image:url(' + pages11[187] + ')'"></div>
            <div :style="'background-image:url(' + pages11[188] + ')'"></div>
            <div :style="'background-image:url(' + pages11[189] + ')'"></div>
            <div :style="'background-image:url(' + pages11[190] + ')'"></div>
            <div :style="'background-image:url(' + pages11[191] + ')'">
              <a class="links articles2" style="bottom:4.6%; left:50.8%; width: 9% " target="_blank"
                @click="openLink('https://www.instagram.com/waltcassidy/?hl=en')">@waltcassidy</a>
            </div>
            <div :style="'background-image:url(' + pages11[192] + ')'"></div>
            <div :style="'background-image:url(' + pages11[193] + ')'"></div>
            <div :style="'background-image:url(' + pages11[194] + ')'"></div>
            <div :style="'background-image:url(' + pages11[195] + ')'"></div>
            <div :style="'background-image:url(' + pages11[196] + ')'"></div>
            <div :style="'background-image:url(' + pages11[197] + ')'"></div>
            <div :style="'background-image:url(' + pages11[198] + ')'"></div>
            <div :style="'background-image:url(' + pages11[199] + ')'"></div>
            <div :style="'background-image:url(' + pages11[200] + ')'"></div>
            <div :style="'background-image:url(' + pages11[201] + ')'"></div>
            <div :style="'background-image:url(' + pages11[202] + ')'"></div>
            <div :style="'background-image:url(' + pages11[203] + ')'">
              <a class="minilinks articles2" style="bottom:4.6%; left:50.8%; width: 7%" target="_blank"
                @click="openLink('https://www.instagram.com/eltonjohn/?hl=en')">@eltonjohn</a>
              <a class="minilinks articles2" style="bottom:4.6%; left:60.8%; width: 9%" target="_blank"
                @click="openLink('https://www.instagram.com/davidfurnish/?hl=en')">@davidfurnish</a>
            </div>
            <div :style="'background-image:url(' + pages11[204] + ')'">
              <a class="links articles2" style="bottom:4.6%; left:50.8%; width: 14%" target="_blank"
                @click="openLink('https://www.instagram.com/michael.jcoppola/?hl=en')">@michael.jcoppola</a>
            </div>
            <div :style="'background-image:url(' + pages11[205] + ')'"></div>
            <div :style="'background-image:url(' + pages11[206] + ')'"></div>
            <div :style="'background-image:url(' + pages11[207] + ')'"></div>
            <div :style="'background-image:url(' + pages11[208] + ')'"></div>
            <div :style="'background-image:url(' + pages11[209] + ')'"></div>
            <div :style="'background-image:url(' + pages11[210] + ')'"></div>
            <div :style="'background-image:url(' + pages11[211] + ')'">
              <a class="minilinks articles2" style="bottom:4.6%; left:50.8%; width: 12%" target="_blank"
                @click="openLink('https://www.instagram.com/officialjakedaniels/?hl=en')">@officialjakedaniels</a>
            </div>
            <div :style="'background-image:url(' + pages11[212] + ')'"></div>
            <div :style="'background-image:url(' + pages11[213] + ')'"></div>
            <div :style="'background-image:url(' + pages11[214] + ')'"></div>
            <div :style="'background-image:url(' + pages11[215] + ')'"></div>
            <div :style="'background-image:url(' + pages11[216] + ')'"></div>
            <div :style="'background-image:url(' + pages11[217] + ')'">
              <a class="minilinks articles2" style="bottom:23.5%; right:4%; width: 13.5%" target="_blank"
              @click="openLink('https://www.eltonjohnaidsfoundation.org/')">eltonjohnaidsfoundation.org</a>
              <a class="minilinks articles2" style="bottom:21.8%; left:50.8%; width: 2%" target="_blank"
              @click="openLink('https://www.eltonjohnaidsfoundation.org/')">eltonjohnaidsfoundation.org</a>
              <a class="minilinks articles2" style="bottom:21.8%; right:19.5%; width: 7.4%" target="_blank"
                @click="openLink('https://www.versace.com/gb/en/')">Versace.com</a>
            </div>
            <div :style="'background-image:url(' + pages11[218] + ')'"></div>
            <div :style="'background-image:url(' + pages11[219] + ')'"></div>
            <div :style="'background-image:url(' + pages11[220] + ')'"></div>
            <div :style="'background-image:url(' + pages11[221] + ')'"></div>
            <div :style="'background-image:url(' + pages11[222] + ')'"></div>
            <div :style="'background-image:url(' + pages11[223] + ')'"></div>
            <div :style="'background-image:url(' + pages11[224] + ')'"></div>
            <div :style="'background-image:url(' + pages11[225] + ')'">
              <a class="minilinks articles2" style="bottom:4.6%; left:50.8%; width: 11%" target="_blank"
                @click="openLink('https://www.instagram.com/prideliveofficial/?hl=en')">@prideliveofficial</a>
            </div>
            <div :style="'background-image:url(' + pages11[226] + ')'">
              <a class="minilinks articles2" style="bottom:4.4%; left:50.8%; width: 15.5%" target="_blank"
                @click="openLink('https://www.instagram.com/maya__papaya26/?hl=en')">@prideliveofficial</a>
            </div>
            <div :style="'background-image:url(' + pages11[227] + ')'"></div>
            <div :style="'background-image:url(' + pages11[228] + ')'"></div>
            <div :style="'background-image:url(' + pages11[229] + ')'"></div>
            <div :style="'background-image:url(' + pages11[230] + ')'">
              <a class="minilinks articles2" style="bottom:37.8%; left:5%; width: 8%" target="_blank"
                @click="openLink('https://www.instagram.com/lalgbtcenter/?hl=en')">@lalgbtcenter</a>
              <a class="minilinks articles2" style="bottom:33%; left:50.8%; width: 11%" target="_blank"
                @click="openLink('https://www.instagram.com/coiledgoldenzaii/?hl=en')">@coiledgoldenzaii</a>
            </div>
            <div :style="'background-image:url(' + pages11[231] + ')'"></div>
            <div :style="'background-image:url(' + pages11[232] + ')'"></div>
            <div :style="'background-image:url(' + pages11[233] + ')'"></div>
            <div :style="'background-image:url(' + pages11[234] + ')'"></div>
            <div :style="'background-image:url(' + pages11[235] + ')'">
              <a class="minilinks articles2" style="bottom:4.6%; left:50.8%; width: 11%" target="_blank"
                @click="openLink('https://www.instagram.com/markkaanthony/?hl=en')">@markkaanthony</a>
            </div>
            <div :style="'background-image:url(' + pages11[236] + ')'">
              <a class="minilinks articles2" style="bottom:4%; left:50.8%; width: 12%" target="_blank"
                @click="openLink('https://www.tiktok.com/search?q=myayummyy&t=1717016562048')">@myayummyy</a>
            </div>
            <div :style="'background-image:url(' + pages11[237] + ')'"></div>
            <div :style="'background-image:url(' + pages11[238] + ')'"></div>
            <div :style="'background-image:url(' + pages11[239] + ')'"></div>
            <div :style="'background-image:url(' + pages11[240] + ')'"></div>
            <div :style="'background-image:url(' + pages11[241] + ')'">
              <a class="minilinks articles2" style="bottom:4.6%; left:50.8%; width: 10%" target="_blank"
                @click="openLink('https://www.instagram.com/mjrodriguez7/?hl=en')">@mjrodriguez7</a>
            </div>
            <div :style="'background-image:url(' + pages11[242] + ')'"></div>
            <div :style="'background-image:url(' + pages11[243] + ')'"></div>
            <div :style="'background-image:url(' + pages11[244] + ')'"></div>
            <div :style="'background-image:url(' + pages11[245] + ')'"></div>
            <div :style="'background-image:url(' + pages11[246] + ')'"></div>
            <div :style="'background-image:url(' + pages11[247] + ')'">
              <a class="minilinks articles2" style="bottom:4.6%; left:50.8%; width: 13.2%" target="_blank"
                @click="openLink('https://www.instagram.com/artivistmonicaraye/?hl=en')">@artivistmonicaraye</a>
            </div>
            <div :style="'background-image:url(' + pages11[248] + ')'"></div>
            <div :style="'background-image:url(' + pages11[249] + ')'"></div>
            <div :style="'background-image:url(' + pages11[250] + ')'"></div>
            <div :style="'background-image:url(' + pages11[251] + ')'">
              <a class="minilinks articles2" style="bottom:4.6%; left:50.8%; width: 9.5%" target="_blank"
                @click="openLink('https://www.instagram.com/arianadebose/?hl=en')">@arianadebose</a>
            </div>
            <div :style="'background-image:url(' + pages11[252] + ')'"></div>
            <div :style="'background-image:url(' + pages11[253] + ')'"></div>
            <div :style="'background-image:url(' + pages11[254] + ')'"></div>
            <div :style="'background-image:url(' + pages11[255] + ')'"></div>
            <div :style="'background-image:url(' + pages11[256] + ')'"></div>
            <div :style="'background-image:url(' + pages11[257] + ')'">
              <a class="minilinks articles2" style="bottom:4.6%; left:50.8%; width: 10.4%" target="_blank"
                @click="openLink('https://www.instagram.com/dr_sappho/?hl=en')">@dr_sappho</a>
            </div>
            <div :style="'background-image:url(' + pages11[258] + ')'"></div>
            <div :style="'background-image:url(' + pages11[259] + ')'"></div>
            <div :style="'background-image:url(' + pages11[260] + ')'"></div>
            <div :style="'background-image:url(' + pages11[261] + ')'">
              <a class="minilinks articles2" style="bottom:4.6%; left:50.8%; width: 7%" target="_blank"
                @click="openLink('https://www.instagram.com/briiiiiiiiiig/?hl=en')">@briiiiiiiiiig</a>
            </div>
            <div :style="'background-image:url(' + pages11[262] + ')'">
              <a class="minilinks articles2" style="bottom:4.2%; left:50.8%; width: 17.5%" target="_blank"
                @click="openLink('https://www.instagram.com/style_it_with_violet/?hl=en')">b@style_it_with_violet</a>
            </div>
            <div :style="'background-image:url(' + pages11[263] + ')'"></div>
            <div :style="'background-image:url(' + pages11[264] + ')'">
              <div class="video02">
                <vue-player ref="video2" id="video02"
                  src="https://firebasestorage.googleapis.com/v0/b/mission-magazine-fb409.appspot.com/o/issue-11%2Fmedia%2Fpg264_StressPositions.mp4?alt=media&token=a817d735-b4ef-4067-ac3e-5b8b39b1af71"></vue-player>
              </div>
              <a class="minilinks articles2" style="bottom: 36%; left: 5%; width: 11%; "
                @click.prevent="playVideo02">Click to Play</a>
            </div>
            <div :style="'background-image:url(' + pages11[265] + ')'"></div>
            <div :style="'background-image:url(' + pages11[266] + ')'"></div>
            <div :style="'background-image:url(' + pages11[267] + ')'">
              <a class="minilinks articles2" style="bottom:4.6%; left:50.8%; width: 7%" target="_blank"
                @click="openLink('https://www.instagram.com/qaherhar/?hl=en')">@qaherha</a>
            </div>
            <div :style="'background-image:url(' + pages11[268] + ')'">
              <a class="minilinks articles2" style="bottom:4%; left:50.8%; width: 11%" target="_blank"
                @click="openLink('https://www.instagram.com/willow.tree010/?hl=en')">@willow.tree010 </a>
            </div>
            <div :style="'background-image:url(' + pages11[269] + ')'"></div>
            <div :style="'background-image:url(' + pages11[270] + ')'"></div>
            <div :style="'background-image:url(' + pages11[271] + ')'"></div>
            <div :style="'background-image:url(' + pages11[272] + ')'"></div>
            <div :style="'background-image:url(' + pages11[273] + ')'">
              <a class="minilinks articles2" style="bottom:4.6%; left:50.8%; width: 9.5%" target="_blank"
                @click="openLink('https://www.instagram.com/dineaesthetics/?hl=en')">@dineaesthetics</a>
            </div>
            <div :style="'background-image:url(' + pages11[274] + ')'"></div>
            <div :style="'background-image:url(' + pages11[275] + ')'"></div>
            <div :style="'background-image:url(' + pages11[276] + ')'"></div>
            <div :style="'background-image:url(' + pages11[277] + ')'"></div>
            <div :style="'background-image:url(' + pages11[278] + ')'">
              <a class="minilinks articles2" style="bottom:2.3%; left:17.5%; width: 7.5%" target="_blank"
                @click="openLink('https://www.tomfordfashion.com/')">Tom Ford </a>
            </div>
            <div :style="'background-image:url(' + pages11[279] + ')'"></div>
            <div :style="'background-image:url(' + pages11[280] + ')'"></div>
            <div :style="'background-image:url(' + pages11[281] + ')'">
              <a class="minilinks articles2" style="bottom:4.6%; left:50.8%; width:8.5%" target="_blank"
                @click="openLink('https://www.instagram.com/philipsallon/?hl=en')">@philipsallon</a>
            </div>
            <div :style="'background-image:url(' + pages11[282] + ')'">
              <a class="links articles2" style="bottom:7.4%; left:21.2%; width: 9.8%" target="_blank"
                @click="openLink('https://brianclarke.co.uk/')">Brian Clarke</a>
              <a class="links articles2" style="bottom:4.1%; left:9.2%; width: 14.5%" target="_blank"
                @click="openLink('https://www.viviennewestwood.com/en-us/home/')">Vivienne Westwood</a>
            </div>
            <div :style="'background-image:url(' + pages11[283] + ')'">
              <a class="minilinks articles2" style="bottom:5.6%; right:5.2%; width: 8.4%" target="_blank"
                @click="openLink('https://www.instagram.com/gwbk/?hl=en')">@gwbk</a>
            </div>
            <div :style="'background-image:url(' + pages11[284] + ')'"></div>
            <div :style="'background-image:url(' + pages11[285] + ')'">
              <a class="minilinks articles2"  target="_blank" style="bottom:8.2%; right:20.8%; width: 6%" 
                @click="openLink('https://www.hermes.com/us/en/')">Hermes</a>
              <a class="minilinks articles2" style="bottom:6.6%; right:5.2%; width: 8%" target="_blank"
                @click="openLink('https://www.instagram.com/gwbk/?hl=en')">@gwbk</a>
            </div>
            <div :style="'background-image:url(' + pages11[286] + ')'">
              <a class="minilinks articles2" style="bottom:5.6%; left:17%; width: 10.4%" target="_blank" 
                @click="openLink('https://www.thombrowne.com/us')">Thom Browne</a>
            </div>
            <div :style="'background-image:url(' + pages11[287] + ')'">
              <a class="minilinks articles2" style="bottom:6.8%; right:5.2%; width: 12%" target="_blank"
                @click="openLink('https://www.armani.com/en-us/experience/emporio-armani?_gl=1*1m0av6g*_up*MQ..&gclid=Cj0KCQjw0MexBhD3ARIsAEI3WHIX5VOc4eHxwECuu6JHV5N_3m6ehIa6bV2LSWhDsJIX2AQ8aLuCG2caArCyEALw_wcB&gclsrc=aw.ds')">Emporio
                Armani</a>
            </div>
            <div :style="'background-image:url(' + pages11[288] + ')'">
              <a class="minilinks articles2" style="bottom:5.6%; left:23%; width: 10.4%" target="_blank"
                @click="openLink('https://walesbonner.com/')">Wales Bonner</a>
            </div>
            <div :style="'background-image:url(' + pages11[289] + ')'">
              <a class="minilinks articles2" style="bottom:7.2%; right:5.2%; width: 6%" target="_blank"
                @click="openLink('https://www.viviennewestwood.com/en-us/home/')">Vivienne Westwood</a>
              <a class="minilinks articles2" style="bottom:5.6%; right:24%; width: 7.5%" target="_blank"
                @click="openLink('https://www.viviennewestwood.com/en-us/home/')">Vivienne Westwood</a>
            </div>
            <div :style="'background-image:url(' + pages11[290] + ')'">
              <a class="minilinks articles2" style="bottom:14.6%; left:5%; width: 10.5%" target="_blank"
                @click="openLink('https://us.louisvuitton.com/eng-us/homepage')">Louis Vuitton</a>
            </div>
            <div :style="'background-image:url(' + pages11[291] + ')'"></div>
            <div :style="'background-image:url(' + pages11[292] + ')'"></div>
            <div :style="'background-image:url(' + pages11[293] + ')'"></div>
            <div :style="'background-image:url(' + pages11[294] + ')'"></div>
            <div :style="'background-image:url(' + pages11[295] + ')'"></div>
            <div :style="'background-image:url(' + pages11[296] + ')'"></div>
            <div :style="'background-image:url(' + pages11[297] + ')'"></div>
            <div :style="'background-image:url(' + pages11[298] + ')'"></div>
            <div :style="'background-image:url(' + pages11[299] + ')'"></div>
            <div :style="'background-image:url(' + pages11[300] + ')'">
              <a class="minilinks articles2" style="bottom:4.6%; left:50.8%; width: 11.6%" target="_blank"
                @click="openLink('https://www.instagram.com/mickalenethomas/?hl=en')">@mickalenethomas</a>
            </div>
            <div :style="'background-image:url(' + pages11[301] + ')'"></div>
            <div :style="'background-image:url(' + pages11[302] + ')'"></div>
            <div :style="'background-image:url(' + pages11[303] + ')'"></div>
            <div :style="'background-image:url(' + pages11[304] + ')'"></div>
            <div :style="'background-image:url(' + pages11[305] + ')'">
              <a class="minilinks articles2" style="bottom:4.2%; right:4%; width: 10.8%" target="_blank"
                @click="openLink('https://www.bottegaveneta.com/en-us')">Bottega Veneta </a>
            </div>
            <div :style="'background-image:url(' + pages11[306] + ')'">
              <a class="minilinks articles2" style="bottom:23.2%; left:2.8%; width: 8%" target="_blank"
              @click="openLink('https://www.balenciaga.com/en-us')">Balenciaga</a>
              <a class="minilinks articles2" style="bottom:21.6%; left:2.8%; width: 9.5%" target="_blank"
              @click="openLink('https://www.depop.com/alexjustspat/')">Alex Justspat</a>
              <a class="minilinks articles2" style="bottom:20%; left:10%; width: 11%" target="_blank"
              @click="openLink('https://www.giovanniraspini.com/en-us/')">Giovanni Raspini</a>
              <a class="minilinks articles2" style="bottom:15.2%; left:8.2%; width: 4.5%" target="_blank"
              @click="openLink('https://shop.diesel.com/en/')">Diesel</a>
              <a class="minilinks articles2" style="bottom:10.5%; left:10.6%; width: 9.5%" target="_blank"
              @click="openLink('https://www.depop.com/alexjustspat/')">Alex Justspat</a>
              <a class="minilinks articles2" style="bottom:5.8%; left:4.8%; width: 12%" target="_blank"
              @click="openLink('https://www.giovanniraspini.com/en-us/')">Giovanni Raspini</a>
              <a class="minilinks articles2" style="bottom:4.2%; left:2.8%; width: 21.2%" target="_blank"
                @click="openLink('https://paristexasbrand.com/pages/editorial-nadia-lee-cohen')">Paris Texas X Nadia Lee
                Cohen</a>
            </div>
            <div :style="'background-image:url(' + pages11[307] + ')'">
              <a class="minilinks articles2" style="bottom:9%; right:3%; width: 17%" target="_blank"
                @click="openLink('https://www.celine.com/en-us/home')">Celine</a>
              <a class="minilinks articles2" style="bottom:6%; right:3%; width: 10%" target="_blank"
                @click="openLink('https://www.depop.com/alexjustspat/')">Alex Justspat</a>
              <a class="minilinks articles2" style="bottom:4.4%; right:3%; width: 4%" target="_blank"
                @click="openLink('https://www.falke.com/us_en/')">Falke</a>
            </div>
            <div :style="'background-image:url(' + pages11[308] + ')'"></div>
            <div :style="'background-image:url(' + pages11[309] + ')'">
              <a class="minilinks articles2" style="bottom:13.4%; right:3.5%; width: 18.5%" target="_blank"
                @click="openLink('https://www.michaelkors.com/')">Michael Kors Collection</a>
              <a class="minilinks articles2" style="bottom:11.8%; right:3%; width: 4%" target="_blank"
                @click="openLink('https://blackeyewear.com/en-us')">Black Eyewear </a>
              <a class="minilinks articles2" style="bottom:10.2%; right:15%; width: 6%" target="_blank"
                @click="openLink('https://blackeyewear.com/en-us')">Black Eyewear </a>
              <a class="minilinks articles2" style="bottom:8.6%; right:3%; width: 2.5%" target="_blank"
                @click="openLink('https://thehirstcollection.com/')">The Hirst Collection</a>
              <a class="minilinks articles2" style="bottom:7%; right:6.5%; width: 13%" target="_blank"
                @click="openLink('https://thehirstcollection.com/')">The Hirst Collection</a>
              <a class="minilinks articles2" style="bottom:5.5%; right:3%; width: 9%" target="_blank"
                @click="openLink('https://tillysveaas.co.uk/')">Tilly Sveeas</a>
              <a class="minilinks articles2" style="bottom:4%; right:3%; width: 5.5%" target="_blank"
                @click="openLink('https://www.casadei.com/en/')">Casadei</a>
            </div>
            <div :style="'background-image:url(' + pages11[310] + ')'">
              <a class="minilinks articles2" style="bottom:5.5%; left:9.6%; width: 9%" target="_blank"
                @click="openLink('https://www.prada.com/us/en.html')">Prada</a>
              <a class="minilinks articles2" style="bottom:4%; left:17.6%; width: 9%" target="_blank"
                @click="openLink('https://paristexasbrand.com/')">Paris Texas</a>
            </div>
            <div :style="'background-image:url(' + pages11[311] + ')'">
              <a class="minilinks articles2" style="bottom:18%; right:3%; width: 3.5%" target="_blank"
                @click="openLink('https://www.ralphlauren.com/')">Polo Ralph Lauren</a>
              <a class="minilinks articles2" style="bottom:16.6%; right:9.6%; width: 10%" target="_blank"
                @click="openLink('https://www.ralphlauren.com/')">Polo Ralph Lauren</a>
              <a class="minilinks articles2" style="bottom:13.4%; right:3%; width: 5%" target="_blank"
                @click="openLink('https://www.rokeratelier.com/')">Roker</a>
              <a class="minilinks articles2" style="bottom:7%; right:13%; width: 8%" target="_blank"
                @click="openLink('https://us.burberry.com/')">Burberry</a>
              <a class="minilinks articles2" style="bottom:4%; right:3%; width: 8%" target="_blank"
                @click="openLink('https://paristexasbrand.com/')">Paris Texas</a>
            </div>
            <div :style="'background-image:url(' + pages11[312] + ')'">
              <a class="minilinks articles2" style="bottom:7%; left:16%; width: 4.5%" target="_blank"
                @click="openLink('https://www.dolcegabbana.com/en-us/')">Dolce&Gabbana
              </a>
              <a class="minilinks articles2" style="bottom:5.5%; left:2.5%; width: 8%" target="_blank"
                @click="openLink('https://www.dolcegabbana.com/en-us/')">Dolce&Gabbana
              </a>
              <a class="minilinks articles2" style="bottom:4%; left:8%; width: 4%" target="_blank"
                @click="openLink('https://www.gina.com/en/')">Gina</a>
            </div>
            <div :style="'background-image:url(' + pages11[313] + ')'"></div>
            <div :style="'background-image:url(' + pages11[314] + ')'">
              <a class="minilinks articles2" style="bottom:8.8%; left:17.6%; width:6%" target="_blank"
                @click="openLink('https://www.albertaferretti.com/us_en/')">Alberta Ferretti</a>
              <a class="minilinks articles2" style="bottom:7%; left:2.6%; width:6.5%" target="_blank"
                @click="openLink('https://www.albertaferretti.com/us_en/')">Alberta Ferretti</a>
              <a class="minilinks articles2" style="bottom:5.6%; left:9.5%; width:9.5%" target="_blank"
                @click="openLink('https://atsukokudo.com/Home/')">Atsuko Kudo</a>
            </div>
            <div :style="'background-image:url(' + pages11[315] + ')'">
              <a class="minilinks articles2" style="bottom:11.8%; right:7.5%; width: 7.5%" target="_blank"
                @click="openLink('http://moschino.com')">Moschino</a>
              <a class="minilinks articles2" style="bottom:10.1%; right:3%; width: 6%" target="_blank"
                @click="openLink('https://www.stephenjonesmillinery.com/')">Stephen Jones Millinery</a>
              <a class="minilinks articles2" style="bottom:8.6%; right:9%; width: 12%" target="_blank"
                @click="openLink('https://www.stephenjonesmillinery.com/')">Stephen Jones Millinery</a>
              <a class="minilinks articles2" style="bottom:7%; right:3%; width: 3%" target="_blank"
                @click="openLink('https://thehirstcollection.com/')">The Hirst Collection</a>
              <a class="minilinks articles2" style="bottom:5.5%; right:7.5%; width: 13%" target="_blank"
                @click="openLink('https://thehirstcollection.com/')">The Hirst Collection</a>
              <a class="minilinks articles2" style="bottom:4%; right:3.5%; width: 4%" target="_blank"
                @click="openLink('https://www.gucci.com/us/en/')">Gucci</a>
            </div>
            <div :style="'background-image:url(' + pages11[316] + ')'"></div>
            <div :style="'background-image:url(' + pages11[317] + ')'">
              <a class="minilinks articles2" style="bottom:38.1%; right:3%; width: 5%" target="_blank"
                @click="openLink('https://erdem.com/')">Erdem</a>
              <a class="minilinks articles2" style="bottom:36.5%; right:3%; width: 6%" target="_blank"
                @click="openLink('https://www.stephenjonesmillinery.com/')">Stephen </a>
              <a class="minilinks articles2" style="bottom:34.9%; right:7%; width: 12%" target="_blank"
                @click="openLink('https://www.stephenjonesmillinery.com/')">Stephen Jones Millinery </a>
              <a class="minilinks articles2" style="bottom:33.4%; right:3%; width: 7%" target="_blank"
                @click="openLink('https://thehirstcollection.com/')">The Hirst Collection</a>
              <a class="minilinks articles2" style="bottom:31.7%; right:11%; width: 8.5%" target="_blank"
                @click="openLink('https://thehirstcollection.com/')">The Hirst Collection</a>
              <a class="minilinks articles2" style="bottom:30.2%; right:3%; width: 10%" target="_blank"
                @click="openLink('https://www.paularowan.com/')">Paula Rowan</a>
            </div>
            <div :style="'background-image:url(' + pages11[318] + ')'">
              <a class="minilinks articles2" style="bottom:5.4%; left:12.5%; width: 9.5%" target="_blank"
                @click="openLink('https://atsukokudo.com/Home/')">Atsuko Kudo</a>
              <a class="minilinks articles2" style="bottom:4%; left:12.5%; width: 13%" target="_blank"
                @click="openLink('https://www.dolcegabbana.com/en-us/')">Dolce&Gabbana</a>
            </div>
            <div :style="'background-image:url(' + pages11[319] + ')'">
              <a class="minilinks articles2" style="bottom:5.6%; right:20%; width: 3%" target="_blank"
                @click="openLink('https://www.dior.com/en_gb?adlgid=c%257Cg%257Cdior%257C544968307193%257Ce&gad_source=1&gclid=CjwKCAjwgdayBhBQEiwAXhMxtuKPwVzXgfLgkGE4b_M3KoRTwl7ZBsLluN9Kc9nEdAPx-3ahRpsCExoCwbgQAvD_BwE')">Dior</a>
              <a class="minilinks articles2" style="bottom:5.6%; right:5%; width: 6%" target="_blank"
                @click="openLink('https://www.stephenjonesmillinery.com/')">Stephen</a>
              <a class="minilinks articles2" style="bottom:4%; right:5%; width: 12%" target="_blank"
                @click="openLink('https://www.stephenjonesmillinery.com/')">Stephen Jones Millinery</a>
            </div>
            <div :style="'background-image:url(' + pages11[320] + ')'"></div>
            <div :style="'background-image:url(' + pages11[321] + ')'">
              <a class="minilinks articles2" style="bottom:4.2%; right:3%; width: 5.6%" target="_blank"
                @click="openLink('https://www.chanel.com/us/')">Chanel</a>
            </div>
            <div :style="'background-image:url(' + pages11[322] + ')'">
              <a class="minilinks articles2" style="bottom:16.5%; left:3%; width: 10%" target="_blank"
                @click="openLink('https://us.louisvuitton.com/eng-us/homepage')">Louis Vuitton</a><a
                class="minilinks articles2" style="bottom:15%; left:19.2%; width: 10.5%" target="_blank"
                @click="openLink('https://anabelachan.com/')">Anabela Chan</a>
                <a class="minilinks articles2"
                style="bottom:13.4%; left:12.5%; width: 7%" target="_blank"
                @click="openLink('https://www.wolford.com/en-us/')">Wolford</a>
                <a class="minilinks articles2" style="bottom:11.8%; left:4.8%; width: 5.5%" target="_blank"
                @click="openLink('https://www.casadei.com/en/')">Casadei</a>
                <a class="minilinks articles2"
                style="bottom:10.2%; left:10.5%; width: 7%" target="_blank"
                @click="openLink('https://www.wolford.com/en-us/')">Wolford</a>
                <a class="minilinks articles2"
                style="bottom:10.2%; left:26.6%; width: 4.5%" target="_blank"
                @click="openLink('https://www.rogervivier.com/us-en/home/')">Roger</a>
                <a class="minilinks articles2"
                style="bottom:8.8%; left:3%; width: 4%" target="_blank"
                @click="openLink('https://www.rogervivier.com/us-en/home/')">Vivier</a>
                <a
                class="minilinks articles2" style="bottom:8.8%; left:18%; width: 9.5%" target="_blank"
                @click="openLink('https://atsukokudo.com/Home/')">Atsuko Kudo</a>
                <a class="minilinks articles2"
                style="bottom:7%; left:18.4%; width: 8%" target="_blank"
                @click="openLink('https://www.alexandermcqueen.com/en-us')">Alexander</a>
                <a class="minilinks articles2"
                style="bottom:5.4%; left:3%; width: 7%" target="_blank"
                @click="openLink('https://www.alexandermcqueen.com/en-us')">McQueen</a>
                <a
                class="minilinks articles2" style="bottom:4.2%; left:3%; width: 9%" target="_blank"
                @click="openLink('https://atsukokudo.com/Home/')">Atsuko Kudo</a>
                <a
                class="minilinks articles2" style="bottom:4%; left:22.8%; width: 6%" target="_blank"
                @click="openLink('https://www.muglerusa.com/')">Mugler</a>
            </div>
            <div :style="'background-image:url(' + pages11[323] + ')'"></div>
            <div :style="'background-image:url(' + pages11[324] + ')'">
              <a class="minilinks articles2" style="bottom:5.4%; left:21.5%; width: 5.5%" target="_blank"
                @click="openLink('https://atsukokudo.com/Home/')">Atsuko Kudo</a>
              <a class="minilinks articles2" style="bottom:4.2%; left:3%; width: 4%" target="_blank"
                @click="openLink('https://atsukokudo.com/Home/')">Atsuko Kudo</a>
            </div>
            <div :style="'background-image:url(' + pages11[325] + ')'"></div>
            <div :style="'background-image:url(' + pages11[326] + ')'">
              <a class="minilinks articles2" style="bottom:8.7%; left:4.8%; width: 6.5%" target="_blank"
                @click="openLink('https://www.muglerusa.com/')">Mugler</a>
              <a class="minilinks articles2" style="bottom:7%; left:3%; width: 14%" target="_blank"
                @click="openLink('https://www.agentprovocateur.com/int_en/ ')">Agent Provocateur</a>
              <a class="minilinks articles2" style="bottom:4%; left:10%; width: 11%" target="_blank"
                @click="openLink('https://anabelachan.com/')">Anabela Chan</a>
            </div>
            <div :style="'background-image:url(' + pages11[327] + ')'">
              <a class="minilinks articles2" style="bottom:4.2%; right:3.2%; width: 4%" target="_blank"
                @click="openLink('https://www.gucci.com/us/en/')">Gucci</a>
            </div>
            <div :style="'background-image:url(' + pages11[328] + ')'">
              <a class="minilinks articles2" style="bottom:7%; left:7%; width: 11.5%" target="_blank"
                @click="openLink('https://www.armani.com/en-us/experience/giorgio-armani?_gl=1*g4vr6j*_up*MQ..&gclid=Cj0KCQjw0MexBhD3ARIsAEI3WHIX5VOc4eHxwECuu6JHV5N_3m6ehIa6bV2LSWhDsJIX2AQ8aLuCG2caArCyEALw_wcB&gclsrc=aw.ds')">Giorgio
                Armani </a>
              <a class="minilinks articles2" style="bottom:4%; left:22%; width: 6%" target="_blank"
                @click="openLink('https://us.balmain.com/en')">Balmain</a>
            </div>
            <div :style="'background-image:url(' + pages11[329] + ')'">
              <a class="minilinks articles2" style="bottom:4.2%; right:3%; width: 10%" target="_blank"
                @click="openLink('https://www.ralphlauren.com/')">Ralph Lauren</a>
            </div>
            <div :style="'background-image:url(' + pages11[330] + ')'">
              <a class="minilinks articles2" style="bottom:15%; left:13.5%; width: 6.5%" target="_blank"
                @click="openLink('https://www.muglerusa.com/')">Mugler</a>
              <a class="minilinks articles2" style="bottom:13.4%; left:3%; width: 14%" target="_blank"
                @click="openLink('https://www.agentprovocateur.com/int_en/ ')">Agent Provocateur</a>
              <a class="minilinks articles2" style="bottom:11.9%; left:19.5%; width: 10.5%" target="_blank"
                @click="openLink('https://anabelachan.com/')">Anabela Chan</a>
              <a class="minilinks articles2" style="bottom:10.3%; left:21%; width: 8%" target="_blank"
                @click="openLink('https://www.ferragamo.com/shop/us/en?_gl=1*1ncjgx1*_up*MQ..&gclid=Cj0KCQjw0MexBhD3ARIsAEI3WHIbG0rKIpBWrh_hk1G-90BIVbwp16lU-ADEwNht3B4SZJY5CMSzb2gaAsVlEALw_wcB&gclsrc=aw.ds')">Ferragamo</a>
              <a class="minilinks articles2" style="bottom:8.8%; left:12.5%; width: 12%" target="_blank"
              @click="openLink('https://www.bottegaveneta.com/en-us')">Bottega Veneta</a>
              <a class="minilinks articles2" style="bottom:5.5%; left:3%; width: 10%" target="_blank"
              @click="openLink('https://anabelachan.com/')">Anabela Chan</a>
              <a class="minilinks articles2" style="bottom:4%; left:19.5%; width: 7%" target="_blank"
                @click="openLink('https://us.burberry.com/')">Burberry</a>
            </div>
            <div :style="'background-image:url(' + pages11[331] + ')'">
              <a class="minilinks articles2" style="bottom:8.8%; right:11%; width: 8%" target="_blank"
                @click="openLink('https://www.paulsmith.com/')">Paul Smith</a>
              <a class="minilinks articles2" style="bottom:7.2%; right:13.5%; width: 6.5%" target="_blank"
              @click="openLink('https://www.miumiu.com/us/en.html')">Miu Miu</a>
              <a class="minilinks articles2" style="bottom:5.5%; right:3%; width: 8.5%" target="_blank"
              @click="openLink('https://www.paulsmith.com/')">Paul Smith</a>
              <a class="minilinks articles2" style="bottom:4.2%; right:3%; width: 7%" target="_blank"
                @click="openLink('https://www.church-footwear.com/us/en.html')">Church’s</a>
            </div>
            <div :style="'background-image:url(' + pages11[332] + ')'">
              <a class="minilinks articles2" style="bottom:5.5%; left:15.5%; width:6%" target="_blank"
                @click="openLink('https://www.hermes.com/us/en/')">Hermes</a>
              <a class="minilinks articles2" style="bottom:4%; left:31.5%; width:6%" target="_blank"
                @click="openLink('https://www.hermes.com/us/en/')">Hermes</a>
            </div>
            <div :style="'background-image:url(' + pages11[333] + ')'">
              <a class="minilinks articles2" style="bottom:10.2%; right:12.5%; width: 5%" target="_blank"
                @click="openLink('https://www.gucci.com/us/en/')">Gucci</a>
              <a class="minilinks articles2" style="bottom:8.6%; right:17.5%; width: 7%" target="_blank"
                @click="openLink('https://www.wolford.com/en-us/')">Wolford</a>
              <a class="minilinks articles2" style="bottom:8.6%; right:3%; width: 4%" target="_blank"
                @click="openLink('https://www.rogervivier.com/us-en/home/')">Roger Vivier</a>
              <a class="minilinks articles2" style="bottom:7%; right:23.5%; width: 4%" target="_blank"
                @click="openLink('https://www.rogervivier.com/us-en/home/')">Roger Vivier</a>
              <a class="minilinks articles2" style="bottom:4%; right:20.5%; width:4%" target="_blank"
                @click="openLink('https://www.prada.com/us/en.html')">Prada</a>
              <a class="minilinks articles2" style="bottom:4.2%; right:3%; width: 6.8%" target="_blank"
                @click="openLink('https://www.wolford.com/en-us/')">Wolford</a>
            </div>
            <div :style="'background-image:url(' + pages11[334] + ')'">
              <a class="minilinks articles2" style="bottom:7%; left:32.5%; width: 5%" target="_blank"
                @click="openLink('https://erdem.com/')">Erdem</a>
              <a class="minilinks articles2" style="bottom:5.5%; left:10.5%; width: 10%" target="_blank"
                @click="openLink('https://atsukokudo.com/Home/')">Atsuko Kudo</a>
              <a class="minilinks articles2" style="bottom:4%; left:13%; width: 11%" target="_blank"
                @click="openLink('https://anabelachan.com/')">Anabela Chan</a>
              <a class="minilinks articles2" style="bottom:4%; left:34.5%; width: 6%" target="_blank"
                @click="openLink('https://www.muglerusa.com/')">Mugler</a>
            </div>
            <div :style="'background-image:url(' + pages11[335] + ')'">
              <a class="minilinks articles2" style="bottom:4.2%; right:3%; width: 10.5%" target="_blank"
                @click="openLink('https://anabelachan.com/')">Anabela Chan</a>
            </div>
            <div :style="'background-image:url(' + pages11[336] + ')'">
              <a class="minilinks articles2" style="bottom:5.5%; left:19.8%; width: 5%" target="_blank"
                @click="openLink('https://www.loewe.com/usa/en/home')">Loewe</a>
              <a class="minilinks articles2" style="bottom:4%; left:12.5%; width: 9%" target="_blank"
                @click="openLink('https://www.rogervivier.com/us-en/home/')">Roger Vivier</a>
            </div>
            <div :style="'background-image:url(' + pages11[337] + ')'">
              <a class="minilinks articles2" style="bottom:5.5%; right:11.5%; width: 5%" target="_blank"
                @click="openLink('https://www.gucci.com/us/en/')">Gucci</a>
              <a class="minilinks articles2" style="bottom:4.2%; right:3%; width: 7%" target="_blank"
                @click="openLink('https://www.miumiu.com/us/en.html')">Miu Miu</a>
            </div>
            <div :style="'background-image:url(' + pages11[338] + ')'">
              <a class="minilinks articles2" style="bottom:4%; left:14.5%; width: 7%" target="_blank"
                @click="openLink('https://www.miumiu.com/us/en.html')">Miu Miu</a>
            </div>
            <div :style="'background-image:url(' + pages11[339] + ')'">
              <a class="minilinks articles2" style="bottom:4.2%; right:3%; width: 6%" target="_blank"
                @click="openLink('https://www.versace.com/us/en/')">Versace</a>
            </div>
            <div :style="'background-image:url(' + pages11[340] + ')'">
              <a class="minilinks articles2" style="bottom:5.5%; left:5%; width: 11%" target="_blank"
                @click="openLink('https://www.armani.com/en-us/experience/giorgio-armani?_gl=1*g4vr6j*_up*MQ..&gclid=Cj0KCQjw0MexBhD3ARIsAEI3WHIX5VOc4eHxwECuu6JHV5N_3m6ehIa6bV2LSWhDsJIX2AQ8aLuCG2caArCyEALw_wcB&gclsrc=aw.ds')">Giorgio
                Armani</a>
              <a class="minilinks articles2" style="bottom:4%; left:12.5%; width: 7%" target="_blank"
                @click="openLink('https://www.church-footwear.com/us/en.html')">Church’s</a>
            </div>
            <div :style="'background-image:url(' + pages11[341] + ')'">
              <a class="links articles2" style="bottom:4.2%; right:3%; width: 7%" target="_blank"
                @click="openLink('https://www.miumiu.com/us/en.html')">Miu Miu</a>
            </div>
            <div :style="'background-image:url(' + pages11[342] + ')'">
              <a class="minilinks articles2" style="bottom:4%; left:19.5%; width: 4.5%" target="_blank"
                @click="openLink('https://www.fendi.com/us-en/')">Fendi</a>
            </div>
            <div :style="'background-image:url(' + pages11[343] + ')'">
              <a class="minilinks articles2" style="bottom:5.5%; right:3%; width: 6%" target="_blank"
                @click="openLink('https://www.versace.com/us/en/')">Versace</a>
              <a class="minilinks articles2" style="bottom:4.2%; right:3%; width: 6%" target="_blank"
                @click="openLink('https://www.muglerusa.com/')">Mugler</a>
            </div>
            <div :style="'background-image:url(' + pages11[344] + ')'"></div>
            <div :style="'background-image:url(' + pages11[345] + ')'">  
              <div class="video03">
                <vue-player ref="video3" id="video03"
                  src="https://firebasestorage.googleapis.com/v0/b/mission-magazine-fb409.appspot.com/o/issue-11%2Fmedia%2Fpg345_WIP.mp4?alt=media&token=2090f0f0-ba4a-4740-8bcf-87ea2f5edaf3"></vue-player>
              </div>            
               <!--  <a class="minilinks articles2" style="bottom: 28.5%; right: 2%; width: 10%; "
                @click.prevent="playVideo03">Click to Play</a> -->
                <a class="minilinks articles2" style="bottom: 23.5%; right: 28%; width: 10%; "
                @click.prevent="onPlayerReadybanner01(media[152])">Click to Play</a>
                <a class="minilinks articles2" style="bottom:7%; right:16.5%; width: 10%" target="_blank"
                @click="openLink('https://us.louisvuitton.com/eng-us/homepage')">Louis Vuitton</a>
                <a class="minilinks articles2" style="bottom:5.5%; right:3%; width: 5.6%" target="_blank"
                @click="openLink('https://anabelachan.com/')">Anabela</a>
                <a class="minilinks articles2" style="bottom:4%; right:20%; width: 4%" target="_blank"
                @click="openLink('https://anabelachan.com/')">Chan</a>
                <a class="minilinks articles2" style="bottom:4.1%; right:3%; width: 7%" target="_blank"
                @click="openLink('https://www.wolford.com/en-us/')">Wolford</a>
            </div>
            <div :style="'background-image:url(' + pages11[346] + ')'">
              <a class="minilinks articles2" style="bottom:5.5%; left:3%; width: 6%" target="_blank"
                @click="openLink('https://www.miumiu.com/us/en.html')">Miu Miu</a>
              <a class="minilinks articles2" style="bottom:4.2%; left:3%; width: 4%" target="_blank"
                @click="openLink('https://www.prada.com/us/en.html')">Prada </a>
              <a class="minilinks articles2" style="bottom:4%; left:18.5%; width: 9%" target="_blank"
                @click="openLink('https://eu.jmweston.com/en')">JM Weston</a>
            </div>
            <div :style="'background-image:url(' + pages11[347] + ')'"></div>
            <div :style="'background-image:url(' + pages11[348] + ')'">
              <a class="minilinks articles2" style="bottom:4%; left:16%; width: 5%" target="_blank"
                @click="openLink('https://www.prada.com/us/en.html')">Prada</a>
            </div>
            <div :style="'background-image:url(' + pages11[349] + ')'">
              <a class="minilinks articles2" style="bottom:8.6%; right:3%; width: 3.5%" target="_blank"              @click="openLink('https://www.ralphlauren.com/')">Polo Ralph Lauren</a>
              <a class="minilinks articles2" style="bottom:7%; right:26.5%; width: 10.2%" target="_blank"
              @click="openLink('https://www.ralphlauren.com/')">Polo Ralph Lauren</a>
              <a class="minilinks articles2" style="bottom:5.5%; right:7.2%; width: 7%" target="_blank"
                @click="openLink('https://www.miumiu.com/us/en.html')">Miu Miu</a>
              <a class="minilinks articles2" style="bottom:4%; right:23.5%; width: 4.5%" target="_blank"
              @click="openLink('https://www.prada.com/us/en.html')">Prada</a>
              <a class="minilinks articles2" style="bottom:4.2%; right:3%; width: 9.5%" target="_blank"
              @click="openLink('https://eu.jmweston.com/en')">JM Weston</a>
            </div>
            <div :style="'background-image:url(' + pages11[350] + ')'">
              <a class="minilinks articles2" style="bottom:4%; left:8.5%; width: 8%" target="_blank"
              @click="openLink('https://www.courreges.com/us')">Courrèges</a>
            </div>
            <div :style="'background-image:url(' + pages11[351] + ')'">
              <a class="minilinks articles2" style="bottom:7%; right:3%; width: 6%" target="_blank"
                @click="openLink('https://www.chanel.com/us/')">Chanel</a>
              <a class="minilinks articles2" style="bottom:5.5%; right:3%; width: 4.5%" target="_blank"
              @click="openLink('https://www.prada.com/us/en.html')">Prada</a>
              <a class="minilinks articles2" style="bottom:4.2%; right:3%; width: 9.5%" target="_blank"
              @click="openLink('https://eu.jmweston.com/en')">JM Weston</a>
            </div>
            <div :style="'background-image:url(' + pages11[352] + ')'">
              <a class="minilinks articles2" style="bottom:8.7%; left:8%; width: 6%" target="_blank"
              @click="openLink('https://www.versace.com/us/en/')">Versace</a>
              <a class="minilinks articles2" style="bottom:7%; left:7.8%; width: 11.5%" target="_blank"
              @click="openLink('https://yasmine-eslami.com/en/')">Yasmine Eslami</a>
              <a class="minilinks articles2" style="bottom:5.5%; left:3%; width: 6.5%" target="_blank"
                @click="openLink('https://www.miumiu.com/us/en.html')">Miu Miu</a>
              <a class="minilinks articles2" style="bottom:5.5%; left:25.5%; width: 5%" target="_blank"
              @click="openLink('https://www.prada.com/us/en.html')">Prada</a>
              <a class="minilinks articles2" style="bottom:4%; left:13.5%; width: 9%" target="_blank"
              @click="openLink('https://eu.jmweston.com/en')">JM Weston</a>
            </div>
            <div :style="'background-image:url(' + pages11[353] + ')'">
              <a class="minilinks articles2" style="bottom:7%; right:3%; width: 7%" target="_blank"
              @click="openLink('https://www.driesvannoten.com/en-us')">Dries Van Noten</a>
              <a class="minilinks articles2" style="bottom:5.5%; right:20.5%; width: 5%" target="_blank"
              @click="openLink('https://www.driesvannoten.com/en-us')">Dries Van Noten</a>
              <a class="minilinks articles2" style="bottom:4.2%; right:3%; width: 9.5%" target="_blank"
              @click="openLink('https://www.acnestudios.com/us/en/home')">Acne Studios</a>
            </div>
            <div :style="'background-image:url(' + pages11[354] + ')'">
              <a class="minilinks articles2" style="bottom:7%; left:8%; width: 19%" target="_blank"
                @click="openLink('https://www.ysl.com/en-us')">Saint Laurent</a>
              <a class="minilinks articles2" style="bottom:5.5%; left:3%; width: 8%" target="_blank"
                @click="openLink('https://www.ysl.com/en-us')">Saint Laurent</a>
              <a class="minilinks articles2" style="bottom:4.2%; left:3%; width: 4.5%" target="_blank"
              @click="openLink('https://www.prada.com/us/en.html')">Prada</a>
              <a class="minilinks articles2" style="bottom:4%; left:18.5%; width: 9%" target="_blank"
              @click="openLink('https://eu.jmweston.com/en')">JM Weston</a>
            </div>
            <div :style="'background-image:url(' + pages11[355] + ')'">
              <a class="minilinks articles2" style="bottom:8.7%; right:3%; width: 6%" target="_blank"
              @click="openLink('https://www.hermes.com/us/en/')">Hermes</a>
              <a class="minilinks articles2" style="bottom:4%; right:13%; width: 7%" target="_blank"
                @click="openLink('https://www.miumiu.com/us/en.html')">Miu Miu</a>
              <a class="minilinks articles2" style="bottom:4.2%; right:3%; width: 5%" target="_blank"
              @click="openLink('https://www.prada.com/us/en.html')">Prada</a>
            </div>
            <div :style="'background-image:url(' + pages11[356] + ')'">
              <a class="minilinks articles2" style="bottom:7%; left:18.8%; width: 14.5%" target="_blank"
                @click="openLink('https://www.ralphlauren.com/')">Polo Ralph Lauren</a>
              <a class="minilinks articles2" style="bottom:5.5%; left:13.5%; width: 7%" target="_blank"
                @click="openLink('https://www.miumiu.com/us/en.html')">Miu Miu</a>
              <a class="minilinks articles2" style="bottom:4%; left:4.5%; width: 5%" target="_blank"
              @click="openLink('https://www.prada.com/us/en.html')">Prada</a>
              <a class="minilinks articles2" style="bottom:4%; left:18.8%; width: 9.5%" target="_blank"
              @click="openLink('https://eu.jmweston.com/en')">JM Weston</a>
            </div>
            <div :style="'background-image:url(' + pages11[357] + ')'">
              <a class="minilinks articles2" style="bottom:8.7%; right:3%; width: 12%" target="_blank"
              @click="openLink('https://www.armani.com/en-us/experience/emporio-armani?_gl=1*1m0av6g*_up*MQ..&gclid=Cj0KCQjw0MexBhD3ARIsAEI3WHIX5VOc4eHxwECuu6JHV5N_3m6ehIa6bV2LSWhDsJIX2AQ8aLuCG2caArCyEALw_wcB&gclsrc=aw.ds')">Emporio Armani</a>
              <a class="minilinks articles2" style="bottom:7%; right:3%; width: 11%" target="_blank"
              @click="openLink('https://yasmine-eslami.com/en/')">Yasmine Eslami</a>
              <a class="minilinks articles2" style="bottom:5.5%; right:7%; width: 4.5%" target="_blank"
              @click="openLink('https://www.prada.com/us/en.html')">Prada</a>
              <a class="minilinks articles2" style="bottom:4.2%; right:3%; width: 9%" target="_blank"
              @click="openLink('https://eu.jmweston.com/en')">JM Weston</a>
            </div>
            <div :style="'background-image:url(' + pages11[358] + ')'">
              <a class="minilinks articles2" style="bottom:5.5%; left:3%; width: 6%" target="_blank"
              @click="openLink('https://www.hermes.com/us/en/')">Hermes</a>
              <a class="minilinks articles2" style="bottom:4.2%; left:3%; width: 5%" target="_blank"
              @click="openLink('https://www.prada.com/us/en.html')">Prada</a>
              <a class="minilinks articles2" style="bottom:4%; left:17.5%; width: 9%" target="_blank"
              @click="openLink('https://eu.jmweston.com/en')">JM Weston</a>
            </div>
            <div :style="'background-image:url(' + pages11[359] + ')'">
              <a class="minilinks articles2" style="bottom:7%; right:3%; width: 6%" target="_blank"
              @click="openLink('https://www.versace.com/us/en/')">Versace</a>
              <a class="minilinks articles2" style="bottom:5.5%; right:3%; width: 4.5%" target="_blank"
              @click="openLink('https://www.prada.com/us/en.html')">Prada</a>
              <a class="minilinks articles2" style="bottom:4.2%; right:3%; width: 9%" target="_blank"
              @click="openLink('https://eu.jmweston.com/en')">JM Weston</a>
            </div>
            <div :style="'background-image:url(' + pages11[360] + ')'">
              <a class="minilinks articles2" style="bottom:4%; left:17.8%; width: 7%" target="_blank"
                @click="openLink('https://www.miumiu.com/us/en.html')">Miu Miu</a>
            </div>
            <div :style="'background-image:url(' + pages11[361] + ')'">
              <a class="minilinks articles2" style="bottom:5.5%; right:3%; width: 4%" target="_blank"
                @click="openLink('https://www.numeroventuno.com/en-us/')">No. 21</a>
              <a class="minilinks articles2" style="bottom:4.2%; right:3%; width: 7%" target="_blank"
              @click="openLink('https://www.miumiu.com/us/en.html')">Miu Miu</a>
            </div>
            <div :style="'background-image:url(' + pages11[362] + ')'">
              <a class="minilinks articles2" style="bottom:5.5%; left:21%; width: 5%" target="_blank"
              @click="openLink('https://www.prada.com/us/en.html')">Prada</a>
              <a class="minilinks articles2" style="bottom:4%; left:20%; width: 6%" target="_blank"
                @click="openLink('https://www.miumiu.com/us/en.html')">Miu Miu</a>
            </div>
            <div :style="'background-image:url(' + pages11[363] + ')'">
              <a class="minilinks articles2" style="bottom:15.4%; right:3%; width: 4.5%" target="_blank"
                @click="openLink('https://us.louisvuitton.com/eng-us/homepage')">Louis Vuitton</a>
              <a class="minilinks articles2" style="bottom:13.7%; right:20.5%; width: 6%" target="_blank"
                @click="openLink('https://us.louisvuitton.com/eng-us/homepage')">Louis Vuitton</a>
              <a class="minilinks articles2" style="bottom:12.1%; right:19.2%; width: 7%" target="_blank"
                @click="openLink('https://www.miumiu.com/us/en.html')">Miu Miu</a>
              <a class="minilinks articles2" style="bottom:10.5%; right:21.2%; width: 7%" target="_blank"
              @click="openLink('https://www.prada.com/us/en.html')">Prada</a>
              <a class="minilinks articles2" style="bottom:10.5%; right:3.5%; width: 9%" target="_blank"
              @click="openLink('https://eu.jmweston.com/en')">JM Weston</a>
            </div>
            <div :style="'background-image:url(' + pages11[364] + ')'">
              <a class="minilinks articles2" style="bottom:4.2%; left:3%; width: 10%" target="_blank"
              @click="openLink('https://us.isabelmarant.com/')">Isabel Marant</a>
            </div>
            <div :style="'background-image:url(' + pages11[365] + ')'"></div>
            <div :style="'background-image:url(' + pages11[366] + ')'"></div>
            <div :style="'background-image:url(' + pages11[367] + ')'">
              <a class="minilinks articles2" style="bottom:4.2%; right:3%; width: 5%" target="_blank"
              @click="openLink('https://www.loewe.com/usa/en/home')">Loewe</a>
            </div>
            <div :style="'background-image:url(' + pages11[368] + ')'">
              <a class="minilinks articles2" style="bottom:4%; left:5%; width: 15%" target="_blank"
              @click="openLink('https://www.alexandermcqueen.com/en-us')">Alexander McQueen</a>
            </div>
            <div :style="'background-image:url(' + pages11[369] + ')'">
              <a class="minilinks articles2" style="bottom:5.5%; right:4.5%; width: 12%" target="_blank"
              @click="openLink('https://theshopyohjiyamamoto.com/')">Yohji Yamamoto</a>
            </div>
            <div :style="'background-image:url(' + pages11[370] + ')'"></div>
            <div :style="'background-image:url(' + pages11[371] + ')'">
              <a class="minilinks articles2" style="bottom:4.2%; right:3%; width: 5.5%" target="_blank"
              @click="openLink('https://www.versace.com/us/en/')">Versace</a>
            </div>
            <div :style="'background-image:url(' + pages11[372] + ')'">
              <a class="minilinks articles2" style="bottom:7%; left:15.5%; width: 6%" target="_blank"
                @click="openLink('https://us.louisvuitton.com/eng-us/homepage')">Louis Vuitton</a>
              <a class="minilinks articles2" style="bottom:5.5%; left:3%; width: 6%" target="_blank"
                @click="openLink('https://us.louisvuitton.com/eng-us/homepage')">Louis Vuitton</a>
              <a class="minilinks articles2" style="bottom:4%; left:5.5%; width: 11%" target="_blank"
              @click="openLink('https://theshopyohjiyamamoto.com/')">Yohji Yamamoto</a>
            </div>
            <div :style="'background-image:url(' + pages11[373] + ')'">
              <a class="links articles2" style="bottom:4.2%; right:3%; width: 7%" target="_blank"
                @click="openLink('https://us.burberry.com/')">burberry</a>
            </div>
            <div :style="'background-image:url(' + pages11[374] + ')'">
              <a class="minilinks articles2" style="bottom:5.5%; left:12.2%; width:11%" target="_blank"
                @click="openLink('https://www.celine.com/en-us/home')">Celine</a>
              <a class="minilinks articles2" style="bottom:4.2%; left:3%; width:11%" target="_blank"
                @click="openLink('https://www.celine.com/en-us/home')">Celine</a>
              <a class="minilinks articles2" style="bottom:4%; left:19.4%; width: 4%" target="_blank"
              @click="openLink('https://www.dior.com/en_gb?adlgid=c%257Cg%257Cdior%257C544968307193%257Ce&gad_source=1&gclid=CjwKCAjwgdayBhBQEiwAXhMxtuKPwVzXgfLgkGE4b_M3KoRTwl7ZBsLluN9Kc9nEdAPx-3ahRpsCExoCwbgQAvD_BwE')">Dior</a>
            </div>
            <div :style="'background-image:url(' + pages11[375] + ')'"></div>
            <div :style="'background-image:url(' + pages11[376] + ')'">
              <a class="minilinks articles2" style="bottom:12%; left:3%; width: 9%" target="_blank"
              @click="openLink('https://us-store.isseymiyake.com/')">Issey Miyake</a>
              <a class="minilinks articles2" style="bottom:10.2%; left:4.5% ; width: 7%" target="_blank"
              @click="openLink('https://www.miumiu.com/us/en.html')">Miu Miu</a>
              <a class="minilinks articles2" style="bottom:8.7%; left:8.5% ; width: 4.5%" target="_blank"
              @click="openLink('https://www.gucci.com/us/en/')">Gucci</a>
              <a class="minilinks articles2" style="bottom:5.5%; left:16.5% ; width: 6%" target="_blank"
              @click="openLink('https://www.hermes.com/us/en/')">Hermes</a>
              <a class="minilinks articles2" style="bottom:4%; left:19%; width: 4.5%" target="_blank"
              @click="openLink('https://www.gucci.com/us/en/')">Gucci</a>
            </div>
            <div :style="'background-image:url(' + pages11[377] + ')'"></div>
            <div :style="'background-image:url(' + pages11[378] + ')'"></div>
            <div :style="'background-image:url(' + pages11[379] + ')'">
              <a class="links articles2" style="bottom:4.2%; right:5%" target="_blank"
              @click="openLink('https://www.prada.com/us/en.html')">Prada</a>
            </div>
            <div :style="'background-image:url(' + pages11[380] + ')'">
              <a class="links articles2" style="bottom:5.5%; left:3%; width:17%" target="_blank"
              @click="openLink('https://www.celine.com/en-us/home')">Celine</a>
              <a class="minilinks articles2" style="bottom:4%; left:13.5%; width: 12%" target="_blank"
            @click="openLink('https://theshopyohjiyamamoto.com/')">Yohji Yamamoto</a>
            </div>
            <div :style="'background-image:url(' + pages11[381] + ')'">
              <a
                class="minilinks articles2" style="bottom:7%; right:5.6%; width: 6.5%" target="_blank"
                @click="openLink('https://www.muglerusa.com/')">Mugler</a>
              <a class="links articles2" style="bottom:4.2%; right:3%" target="_blank"
              @click="openLink('https://www.gucci.com/us/en/')">Gucci</a>
           </div>
            <div :style="'background-image:url(' + pages11[382] + ')'">
              <a class="minilinks articles2" style="bottom:5.2%; left:6%; width: 6%" target="_blank"
              @click="openLink('https://www.hermes.com/us/en/')">Hermes</a>
            </div>
            <div :style="'background-image:url(' + pages11[383] + ')'">
              <a class="minilinks articles2" style="bottom:4.5%; right:3%; width: 5%" target="_blank"
              @click="openLink('https://www.loewe.com/usa/en/home')">Loewe</a>
            </div>
            <div :style="'background-image:url(' + pages11[384] + ')'">
              <a class="minilinks articles2" style="bottom:4%; left:15.5%; width: 6%" target="_blank"
              @click="openLink('https://www.versace.com/us/en/')">Versace</a>
            </div>
            <div :style="'background-image:url(' + pages11[385] + ')'"></div>
            <div :style="'background-image:url(' + pages11[386] + ')'"></div>
            <div :style="'background-image:url(' + pages11[387] + ')'"></div>
            <!-------------->
            <!-- Stockist -->
            <!-------------->
            <div :style="'background-image:url(' + pages11[388] + ')'"> <!-- left -->
             <a class="links articles2" style="bottom:73%; left:26%" target="_blank"
                @click="openLink('https://www.acnestudios.com/us/en/home')">Acne Studios</a>
              <a class="links articles2" style="bottom:68%; left:26%" target="_blank"
                @click="openLink('https://www.agentprovocateur.com/int_en/ ')">Agent Provocateur</a>
              <a class="links articles2" style="bottom:63%; left:26%" target="_blank"
                @click="openLink('https://www.maison-alaia.com/us')">maison - alaia.</a>
              <a class="links articles2" style="bottom:58.1%; left:26%" target="_blank"
                @click="openLink('https://www.albertaferretti.com/us_en/')">Alberta Ferretti</a>
              <a class="links articles2" style="bottom:53.2%; left:26%" target="_blank"
                @click="openLink('https://www.depop.com/alexjustspat/')">depop Alex Justspat</a>
              <a class="links articles2" style="bottom:48.2%; left:26%" target="_blank"
                @click="openLink('https://www.alexandermcqueen.com/en-us')">Alexander McQueen</a>
              <a class="links articles2" style="bottom:43.3%; left:26%" target="_blank"
                @click="openLink('https://anabelachan.com/')">Anabela Chan</a>
              <a class="links articles2" style="bottom:38.3%; left:26%" target="_blank"
                @click="openLink('https://www.asket.com/us')">Asket/</a>
              <a class="links articles2" style="bottom:33.4%; left:26%" target="_blank"
                @click="openLink('https://atsukokudo.com/Home/')">Atsuko Kudo</a>
              <a class="links articles2" style="bottom:28.5%; left:26%" target="_blank"
                @click="openLink('https://www.balenciaga.com/en-us')">Balenciaga</a>
              <a class="links articles2" style="bottom:23.5%; left:26%" target="_blank"
                @click="openLink('https://us.balmain.com/en')">Balmain</a>
              <!-- right -->
              <a class="links articles2" style="bottom:73%; left:61.2%" target="_blank"
                @click="openLink('https://blackeyewear.com/en-us')">Black Eyewear</a>
              <a class="links articles2" style="bottom:68%; left:61.2%" target="_blank"
                @click="openLink('https://www.bottegaveneta.com/en-us')">Bottega Veneta</a>
              <a class="links articles2" style="bottom:63%; left:61.2%" target="_blank"
                @click="openLink('https://brianclarke.co.uk/')">Brian Clarke</a>
              <a class="links articles2" style="bottom:58.1%; left:61.2%" target="_blank"
                @click="openLink('https://us.burberry.com/')">Burberry</a>
              <a class="links articles2" style="bottom:53.2%; left:61.2%" target="_blank"
                @click="openLink('https://www.casadei.com/en/')">Casadei</a>
              <a class="links articles2" style="bottom:48.2%; left:61.2%" target="_blank"
                @click="openLink('https://www.celine.com/en-us/home')">Celine</a>
              <a class="links articles2" style="bottom:43.3%; left:61.2%" target="_blank"
                @click="openLink('https://www.chanel.com/us/')">Chanel</a>
              <a class="links articles2" style="bottom:38.3%; left:61.2%" target="_blank"
                @click="openLink('https://www.church-footwear.com/us/en.html')">church-footwear</a>
              <a class="links articles2" style="bottom:33.4%; left:61.2%" target="_blank"
                @click="openLink('https://shop.cleanwaves.com/')">Clean Waves</a>
              <a class="links articles2" style="bottom:28.5%; left:61.2%" target="_blank"
                @click="openLink('https://www.courreges.com/us')">courreges</a>
              <a class="links articles2" style="bottom:23.5%; left:61.2%" target="_blank"
                @click="openLink('https://daccori.com/')">D’accori</a>
            </div>
            <div :style="'background-image:url(' + pages11[389] + ')'">
             <!-- left -->
             <a class="links articles2" style="bottom:73%; left:5%" target="_blank"
                @click="openLink('https://shop.diesel.com/en/')">diesel</a>
              <a class="links articles2" style="bottom:68%; left:5%" target="_blank"
                @click="openLink('https://www.dior.com/en_gb?adlgid=c%257Cg%257Cdior%257C544968307193%257Ce&gad_source=1&gclid=CjwKCAjwgdayBhBQEiwAXhMxtuKPwVzXgfLgkGE4b_M3KoRTwl7ZBsLluN9Kc9nEdAPx-3ahRpsCExoCwbgQAvD_BwE')">Dior</a>
              <a class="links articles2" style="bottom:63%; left:5%" target="_blank"
                @click="openLink('https://www.dolcegabbana.com/en-us/')">dolcegabbana</a>
              <a class="links articles2" style="bottom:58.1%; left:5%" target="_blank"
                @click="openLink('https://www.driesvannoten.com/en-us')">Dries Van Noten</a>
              <a class="links articles2" style="bottom:53.2%; left:5%"   target="_blank"
                @click="openLink('https://www.armani.com/en-us/experience/emporio-armani?_gl=1*1m0av6g*_up*MQ..&gclid=Cj0KCQjw0MexBhD3ARIsAEI3WHIX5VOc4eHxwECuu6JHV5N_3m6ehIa6bV2LSWhDsJIX2AQ8aLuCG2caArCyEALw_wcB&gclsrc=aw.ds')">Emporio Armani</a>
              <a class="links articles2" style="bottom:48.2%; left:5%" target="_blank"
                @click="openLink('https://erdem.com/')">Erdem</a>
              <a class="links articles2" style="bottom:43.3%; left:5%" target="_blank"
                @click="openLink('https://www.falke.com/us_en/')">Falke</a>
              <a class="links articles2" style="bottom:38.3%; left:5%" target="_blank"
                @click="openLink('https://www.fendi.com/us-en/')">Fendi</a>
              <a class="links articles2" style="bottom:33.4%; left:5%" target="_blank"
                @click="openLink('https://www.ferragamo.com/en-us/')">ferragamo</a>
              <a class="links articles2" style="bottom:28.5%; left:5%" target="_blank"
                @click="openLink('https://www.ganni.com/us/home')">Ganni</a>
              <a class="links articles2" style="bottom:23.5%; left:5%" target="_blank"
                @click="openLink('https://www.gina.com/en/')">Gina</a>
              <!-- right -->
              <a class="links articles2" style="bottom:73%; left:41.2%" target="_blank"
                @click="openLink('https://www.armani.com/en-us/experience/giorgio-armani?_gl=1*g4vr6j*_up*MQ..&gclid=Cj0KCQjw0MexBhD3ARIsAEI3WHIX5VOc4eHxwECuu6JHV5N_3m6ehIa6bV2LSWhDsJIX2AQ8aLuCG2caArCyEALw_wcB&gclsrc=aw.ds')">armani</a>
              <a class="links articles2" style="bottom:68%; left:41.2%" target="_blank"
                @click="openLink('https://www.giovanniraspini.com/en-us/')">Giovanni Raspini</a>
              <a class="links articles2" style="bottom:63%; left:41.2%" target="_blank"
                @click="openLink('https://www.givenchy.com/us/en-US/homepage')">Givenchy </a>
              <a class="links articles2" style="bottom:58.1%; left:41.2%" target="_blank"
                @click="openLink('https://gomi.design/')">Gomi </a>
              <a class="links articles2" style="bottom:53.2%; left:41.2%" target="_blank"
                @click="openLink('https://www.gucci.com/us/en/')">gucci</a>
              <a class="links articles2" style="bottom:48.2%; left:41.2%" target="_blank"
                @click="openLink('https://www.instagram.com/gwbk/?hl=en')">Gwen Baek</a>
              <a class="links articles2" style="bottom:43.3%; left:41.2%" target="_blank"
                @click="openLink('https://www.hermes.com/us/en/')">Hermes</a>
              <a class="links articles2" style="bottom:38.3%; left:41.2%" target="_blank"
                @click="openLink('https://us.isabelmarant.com/')">Isabel Marant</a>
              <a class="links articles2" style="bottom:33.4%; left:41.2%" target="_blank"
                @click="openLink('https://us-store.isseymiyake.com/')">Issey Miyake</a>
              <a class="links articles2" style="bottom:28.5%; left:41.2%" target="_blank"
                @click="openLink('https://eu.jmweston.com/en')">JM Weston</a>
              <a class="links articles2" style="bottom:23.5%; left:41.2%" target="_blank"
                @click="openLink('https://kjaerweis.com/')">Kjar Weis</a>
            
            </div>
            <div :style="'background-image:url(' + pages11[390] + ')'"></div>
            <div :style="'background-image:url(' + pages11[391] + ')'"></div>
            <div :style="'background-image:url(' + pages11[392] + ')'">
            <!-- left -->
            <a class="links articles2" style="bottom:73%; left:26%" target="_blank"
                @click="openLink('https://www.loewe.com/usa/en/home')">Loewe </a>
              <a class="links articles2" style="bottom:68%; left:26%" target="_blank"
                @click="openLink('https://us.louisvuitton.com/eng-us/homepage')">Louis Vuitton</a>
              <a class="links articles2" style="bottom:63%; left:26%" target="_blank"
                @click="openLink('https://www.michaelkors.com/')">Michael Kors</a>
              <a class="links articles2" style="bottom:58.1%; left:26%" target="_blank"
                @click="openLink('https://www.miumiu.com/us/en.html')">Miu Miu</a>
              <a class="links articles2" style="bottom:53.2%; left:26%" target="_blank"
                @click="openLink('https://www.moschino.com/us_en/moschino.html')">Moschino</a>
              <a class="links articles2" style="bottom:48.2%; left:26%" target="_blank"
                @click="openLink('https://mozhdehmatin.com/')">Mozhdeh Matin</a>
              <a class="links articles2" style="bottom:43.3%; left:26%" target="_blank"
                @click="openLink('https://www.muglerusa.com/')">Mugler</a>
              <a class="links articles2" style="bottom:38.3%; left:26%" target="_blank"
                @click="openLink('https://www.numeroventuno.com/en-us/')">numeroventuno</a>
              <a class="links articles2" style="bottom:33.4%; left:26%" target="_blank"
                @click="openLink('https://notobotanics.com/')">notobotanics</a>
              <a class="links articles2" style="bottom:28.5%; left:26%" target="_blank"
                @click="openLink('https://operasport.net/')">Opèrasport</a>
              <!-- right -->
              <a class="links articles2" style="bottom:73%; left:61.2%" target="_blank"
                @click="openLink('https://paristexasbrand.com/')">Paris Texas</a>
              <a class="links articles2" style="bottom:68%; left:61.2%" target="_blank"
                @click="openLink('https://paristexasbrand.com/pages/editorial-nadia-lee-cohen')">Paris Texas X Nadia </a>
              <a class="links articles2" style="bottom:63%; left:61.2%" target="_blank"
                @click="openLink('https://www.paulsmith.com/')">Paul Smith</a>
              <a class="links articles2" style="bottom:58.1%; left:61.2%" target="_blank"
                @click="openLink('https://www.paularowan.com/')">Paula Rowan</a>
              <a class="links articles2" style="bottom:53.2%; left:61.2%" target="_blank"
                @click="openLink('https://www.ralphlauren.com/')">Polo Ralph Lauren</a>
              <a class="links articles2" style="bottom:48.2%; left:61.2%" target="_blank"
                @click="openLink('https://www.prada.com/us/en.html')">Prada </a>
              <a class="links articles2" style="bottom:43.3%; left:61.2%" target="_blank"
                @click="openLink('https://www.raeburndesign.co.uk/')">Ræburn</a>
              <a class="links articles2" style="bottom:38.3%; left:61.2%" target="_blank"
                @click="openLink('https://www.ralphlauren.com/')">Ralph Lauren</a>
              <a class="links articles2" style="bottom:33.4%; left:61.2%" target="_blank"
                @click="openLink('https://www.rogervivier.com/us-en/home/')">Roger Vivier</a>
              <a class="links articles2" style="bottom:28.5%; left:61.2%" target="_blank"
                @click="openLink('https://www.rokeratelier.com/')">rokeratelier</a>
            </div>
            <div :style="'background-image:url(' + pages11[393] + ')'"> <!-- left -->
              <a class="links articles2" style="bottom:73%; left:5%"  target="_blank"
                @click="openLink('https://www.ysl.com/en-us')">Saint Laurent</a>
              <a class="links articles2" style="bottom:68%; left:5%" target="_blank"
                @click="openLink('https://www.saltandstone.com/')">Salt & Stone</a>
              <a class="links articles2" style="bottom:63%; left:5%" target="_blank"
                @click="openLink('https://www.sayebrand.com/')">Sayebrand</a>
              <a class="links articles2" style="bottom:58.1%; left:5%" target="_blank"
                @click="openLink('https://www.sezane.com/us')">Sezane</a>
              <a class="links articles2" style="bottom:53.2%; left:5%" target="_blank"
                @click="openLink('https://www.stellamccartney.com/us/en/')">Stella McCartney </a>
              <a class="links articles2" style="bottom:48.2%; left:5%" target="_blank"
                @click="openLink('https://www.stephenjonesmillinery.com/')">Stephen Jones Millinery </a>
              <a class="links articles2" style="bottom:43.3%; left:5%" target="_blank"
                @click="openLink('https://us.stinegoya.com/')">Stine Goya</a>
              <a class="links articles2" style="bottom:38.3%; left:5%" target="_blank"
                @click="openLink('https://thehirstcollection.com/')">The Hirst Collection</a>
              <a class="links articles2" style="bottom:33.4%; left:5%" target="_blank"
                @click="openLink('https://www.thombrowne.com/us')">Thom Browne</a>
              <a class="links articles2" style="bottom:28.5%; left:5%" target="_blank"
                @click="openLink('https://tillysveaas.co.uk/')">Tilly Sveeas</a>
              <!-- right -->
              <a class="links articles2" style="bottom:73%; left:41.2%" target="_blank"
                @click="openLink('https://www.tomfordfashion.com/')">Tom Ford</a>
              <a class="links articles2" style="bottom:68%; left:41.2%" target="_blank"
                @click="openLink('https://untag.com/')">Untag</a>
              <a class="links articles2" style="bottom:63%; left:41.2%" target="_blank"
                @click="openLink('https://www.versace.com/us/en/')">versace<</a>
              <a class="links articles2" style="bottom:58.1%; left:41.2%" target="_blank"
                @click="openLink('https://www.violettefr.com/products/yeux-paint')">Violette FR</a>
              <a class="links articles2" style="bottom:53.2%; left:41.2%" target="_blank"
                @click="openLink('https://www.viviennewestwood.com/en-us/home/')">Vivienne Westwood</a>
              <a class="links articles2" style="bottom:48.2%; left:41.2%" target="_blank"
                @click="openLink('https://walesbonner.com/')">Wales Bonner</a>
              <a class="links articles2" style="bottom:43.3%; left:41.2%" target="_blank"
                @click="openLink('https://www.wolford.com/en-us/')">wolfordshop</a>
              <a class="links articles2" style="bottom:38.3%; left:41.2%" target="_blank"
                @click="openLink('https://yasmine-eslami.com/en/')">Yasmine Eslami</a>
              <a class="links articles2" style="bottom:33.4%; left:41.2%" target="_blank"
                @click="openLink('https://theshopyohjiyamamoto.com/')">Yohji Yamamoto</a>
              <a class="links articles2" style="bottom:28.5%; left:41.2%" target="_blank"
                @click="openLink('https://zeromariacornejo.com/')">Zero + Maria Cornejo</a>
            </div>
            <div :style="'background-image:url(' + pages11[394] + ')'"></div>
            <div :style="'background-image:url(' + pages11[395] + ')'"></div>
            <div :style="'background-image:url(' + pages11[396] + ')'">
              <a
                class="minilinks articles2"
                style="bottom:10.5%; left:38%; width: 21.8%"
                target="_blank"
                @click="openLink('mailto:info@missionmag.org')"
              >info@missionmag.org</a>
            </div>
            <div :style="'background-image:url(' + pages11[397] + ')'"></div>
            <div :style="'background-image:url(' + pages11[398] + ')'">
              <a class="minilinks articles2" style="bottom:6.5%; left:4%; width: 22%" target="_blank"
                @click="openLink('https://www.eltonjohnaidsfoundation.org/')">Elton John Aids Foundation
              </a>
            </div>
            <!------------------->
            <!-- end issue11  -->
            <!------------------->

          </div>
          <!--------------------->
          <!-- Videos embed -->
          <!--------------------->
          <div class="flipbook-video video-content" id="video-Banner01" v-show="verBanner01">
            <b-embed type="video" :src="infoModalbanner01.src" id="videoBanner01" autoplay allow="autoplay"
              :controls="false" allowfullscreen>
            </b-embed>
          </div>
        </div>
        <index v-if="index"></index>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import '@/lib/turn.js';
import '@/lib/zoom.js';
import '@/lib/hash.js'
import index from './Index'
import loader from "../../containers/loader";
import vuePlayer from '@algoz098/vue-player'
import {
  mapState,
  mapActions,
  mapMutations
} from "vuex";

export default {
  components: {
    index,
    loader,
    vuePlayer
    // navIndex
  },
  data() {
    return {
      estado: '/issue-11',
      infoModalbanner01: {
        src: '',
        isPlay: false,
      },
      verBanner01: false,      
    }
  },
  async beforeMount() {
    await this.loadMagazine11()

  },
  mounted() {

    function loadApp() {
      $("#canvas").fadeIn(4000);
      var o = $(".flipbook");
      0 != o.width() && 0 != o.height() ? (o.turn({
        width: 1650,
        height: 990,
        duration: 4000,
        acceleration: !isChrome(),
        gradients: !0,
        autoCenter: !0,
        elevation: 200,
        when: {
          turning: function (o, i, n) {
            var e = $(this),
              a = e.turn("page");
            e.turn("pages");
            var btnClick = document.getElementById('btnClick');
            /*Cuando se haga clic*/
            btnClick.onmousedown = function () {
              const media1 = document.getElementById("videoBanner01");
              media1.pause();
              $("#video-Banner01").hide();
              //pauseVideo()
            };
            disableControls(i),
              $(".thumbnails .page-" + a).parent().removeClass("current"),
              $(".thumbnails .page-" + i).parent().addClass("current")
          },
          turned: function (o, i, n) {
            disableControls(i), $(this).turn("center"), 1 == i && $(this).turn("peel", "br")
          },
          missing: function (o, i) {
            for (var n = 0; n < i.length; n++) addPage(i[n], $(this))
          }
        }
      }), $(".flipbook-viewport").zoom({
        flipbook: $(".flipbook"),
        max: function () {
          return largeMagazineWidth() / $(".flipbook").width()
        },
        when: {
          swipeLeft: function () {
            $(this).zoom("flipbook").turn("next")
          },
          swipeRight: function () {
            $(this).zoom("flipbook").turn("previous")
          },
          resize: function (o, i, n, e) {
            1 == i ? loadSmallPage(n, e) : loadLargePage(n, e)
          },
          zoomIn: function () {
            $(".thumbnails").hide(), $(".made").hide(),
              $(".flipbook").removeClass("animated").addClass("zoom-in"),
              $(".zoom-icon").removeClass("zoom-icon-in").addClass("zoom-icon-out"),
              window.escTip || $.isTouch || (escTip = !0)
          },
          zoomOut: function () {
            $(".exit-message").hide(),
              $(".made").fadeIn(),
              $(".zoom-icon").removeClass("zoom-icon-out").addClass("zoom-icon-in"),
              setTimeout(function () {
                $(".flipbook").addClass("animated").removeClass("zoom-in"), resizeViewport()
              }, 0)
          }
        }
      }),
        // pasar hojas con flechas

        $(document).keydown(function (e) {
          var options = $('.flipbook').turn('options');

          var previous = 37,
            next = 39,
            esc = 27;

          switch (e.keyCode) {
            case previous:

              // left arrow
              $('.flipbook').turn('previous');
              e.preventDefault();
              break;

            case next:
              //right arrow
              $('.flipbook').turn('next');
              e.preventDefault();
              break;

            case esc:
              $(".flipbook").turn("size", options.width, options.height);
              e.preventDefault();

              break;
          }
        }),
        $(window).resize(function () {
          resizeViewport()
        }).bind("orientationchange", function () {
          resizeViewport()
        }),
        // $.isTouch ? $(".flipbook").bind("touchstart", regionClick) : $(".flipbook").click(regionClick), 
        resizeViewport(),
        $(".flipbook").addClass("animated")) : setTimeout(loadApp, 10)
    }
    $(".zoom-icon").bind("mouseover", function () {
      $(this).hasClass("zoom-icon-in") && $(this).addClass("zoom-icon-in-hover"),
        $(this).hasClass("zoom-icon-out") && $(this).addClass("zoom-icon-out-hover")
    }).on("mouseout", function () {
      $(this).hasClass("zoom-icon-in") && $(this).removeClass("zoom-icon-in-hover"),
        $(this).hasClass("zoom-icon-out") && $(this).removeClass("zoom-icon-out-hover")
    }).on("click", function () {
      toggleFullscreen()
    }), $("#canvas").hide()

    //FUNCTIONS TURNJS
    function resizeViewport() {

      var width = $(window).width(),
        height = $(window).height(),
        options = $('.flipbook').turn('options');

      $('.flipbook').removeClass('animated');

      $('.flipbook-viewport').css({
        width: width,
        height: height
      }).zoom('resize');

      if ($('.flipbook').turn('zoom') == 1) {
        var bound = calculateBound({
          width: options.width,
          height: options.height,
          boundWidth: Math.min(options.width, width),
          boundHeight: Math.min(options.height, height)
        });

        if (bound.width % 2 !== 0)
          bound.width -= 1;

        if (bound.width != $('.flipbook').width() || bound.height != $('.flipbook').height()) {

          $('.flipbook').turn('size', bound.width, bound.height);

          if ($('.flipbook').turn('page') == 1)
            $('.flipbook').turn('peel', 'br');

          $('.next-button').css({
            height: bound.height,
            backgroundPosition: '-38px ' + (bound.height / 2 - 32 / 2) + 'px'
          });
          $('.previous-button').css({
            height: bound.height,
            backgroundPosition: '-4px ' + (bound.height / 2 - 32 / 2) + 'px'
          });
        }

        $('.flipbook').css({
          top: -bound.height / 2,
          left: -bound.width / 2
        });
        $(".flipbook-video").css({
          width: bound.width,
          height: bound.height,
          top: -bound.height / 2,
          left: -bound.width / 2,
          padding: 15,
        });

      }

      var magazineOffset = $('.flipbook').offset(),
        boundH = height - magazineOffset.top - $('.flipbook').height(),
        marginTop = (boundH - $('.thumbnails > div').height()) / 2;

      if (marginTop < 0) {
        $('.thumbnails').css({
          height: 1
        });
      } else {
        $('.thumbnails').css({
          height: boundH
        });
        $('.thumbnails > div').css({
          marginTop: marginTop
        });
      }

      if (magazineOffset.top < $('.made').height())
        $('.made').hide();
      else
        $('.made').show();

      $('.flipbook').addClass('animated');

    }

    function isChrome() {
      return navigator.userAgent.indexOf('Chrome') != -1;
    }

    function calculateBound(d) {

      var bound = {
        width: d.width,
        height: d.height
      };

      if (bound.width > d.boundWidth || bound.height > d.boundHeight) {

        var rel = bound.width / bound.height;

        if (d.boundWidth / rel > d.boundHeight && d.boundHeight * rel <= d.boundWidth) {

          bound.width = Math.round(d.boundHeight * rel);
          bound.height = d.boundHeight;

        } else {

          bound.width = d.boundWidth;
          bound.height = Math.round(d.boundWidth / rel);

        }
      }

      return bound;
    }

    function toggleFullscreen(elem) {
      var options = $('.flipbook').turn('options');

      elem = elem || document.documentElement;
      if (!document.fullscreenElement && !document.mozFullScreenElement &&
        !document.webkitFullscreenElement && !document.msFullscreenElement) {

        if (elem.requestFullscreen) {
          elem.requestFullscreen();
          $(".flipbook").turn("zoom", 1.20);
          $(".flipbook").turn("center");
        } else if (elem.msRequestFullscreen) {
          elem.msRequestFullscreen();
          $(".flipbook").turn("zoom", 1.20);
          $(".flipbook").turn("center");
        } else if (elem.mozRequestFullScreen) {
          elem.mozRequestFullScreen();
          $(".flipbook").turn("zoom", 1.20);
          $(".flipbook").turn("center");
        } else if (elem.webkitRequestFullscreen) {
          elem.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
          $(".flipbook").turn("zoom", 1.20);
          $(".flipbook").turn("center");
        }
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
          $(".flipbook").turn("size", options.width, options.height);
          $(".flipbook").turn("center");
          //$(".flipbook").turn("zoom", 1);
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
          $(".flipbook").turn("size", options.width, options.height);
          $(".flipbook").turn("center");
          //$(".flipbook").turn("zoom", 1);
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
          $(".flipbook").turn("size", options.width, options.height);
          $(".flipbook").turn("center");
          //$(".flipbook").turn("zoom", 1);
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
          $(".flipbook").turn("size", options.width, options.height);
          $(".flipbook").turn("center");
          //$(".flipbook").turn("zoom", 1);
        }
      }
    }

    function disableControls(page) {
      if (page == 1)
        $('.previous-button').hide();
      else
        $('.previous-button').show();

      if (page == $('.flipbook').turn('pages'))
        $('.next-button').hide();
      else
        $('.next-button').show();
    }

    function loadSmallPage(page, pageElement) {

      var img = pageElement.find('img');

      img.css({
        width: '100%',
        height: '100%'
      });

      img.unbind('load');
      // Loadnew page

      //  img.attr('src', 'pages/' + page + '.jpg');
    }

    // large page
    function loadLargePage(page, pageElement) {


      var img = $('<img />');

      img.load(function () {

        var prevImg = pageElement.find('img');

        $(this).css({
          width: '100%',
          height: '100%'
        });
        $(this).appendTo(pageElement);
        prevImg.remove();

      });
    }

    loadApp()

  },
  methods: {
    onPlayerReadybanner01(reproducir, mini) {
      this.infoModalbanner01.isPlay = true;
      this.infoModalbanner01.src = reproducir;
      setTimeout(() => {
        const media = document.getElementById("videoBanner01");
        media.load();
        media.play();
        this.infoModalbanner01.isPlay = true;
        this.verBanner01 = true;
      }, 100);
    },

    cambiarEstado(newEstado) {
      this.estado = newEstado;
      if (newEstado == '/index') {
        this.setClass(true)
        this.pause();
      } else {
        this.$router.push(this.estado)
        this.setClass(false)
        this.pause();
      }
    },
    openLink(url) {
      window.open(url)
    },

    pause() {
      if (this.infoModalbanner01.isPlay == true) {
        const media = document.getElementById("videoBanner01");
        media.pause();
        this.verBanner01 = false;
        this.infoModalbanner01.isPlay = false;
      }
      if (this.$refs.video1.playing == true) {
        this.$refs.video1.playing == false
        this.$refs.video1.$refs.video.pause()
      }
      if (this.$refs.video2.playing == true) {
        this.$refs.video2.playing == false
        this.$refs.video2.$refs.video.pause()
      }
      if (this.$refs.video3.playing == true) {
        this.$refs.video3.playing == false
        this.$refs.video3.$refs.video.pause()
      }
    },

    playVideo01() {
      this.$refs.video1.$refs.video.load();
      this.$refs.video1.$refs.video.play()
    },
    playVideo02() {
      this.$refs.video2.$refs.video.load();
      this.$refs.video2.$refs.video.play()
    },
    playVideo03() {
      this.$refs.video3.$refs.video.load();
      this.$refs.video3.$refs.video.play()
    },
    pageNext() {
      $('.flipbook').turn('next');
      this.pause()
    },
    pagePrev() {
      $('.flipbook').turn('previous');;
      this.pause()
    },
    openBook() {
      let route = this.$router.resolve("/colorbook/11");
      window.open(route.href, "_blank");
    },

    ...mapActions('magazine', [
      'loadMagazine11'
    ]),
    ...mapMutations('magazine', [
      'setClass'
    ]),
  },
  computed: {
    watchCover(){
      return this.seeCover
    },
    ...mapState('magazine', [
      'index',
      'pages11',
      'loading',
      'seeCover',
      'media',
    ])
  },

}
</script>

<style lang="scss">
video {
  object-fit: cover !important;
}

.video01 {
  position: absolute;
  top: 5%;
  margin-left: 4.5%;
  width: 90.8%;
  z-index: 12;
}

#video01 {
  .vue-video-player-controls {
    max-height: 5px !important;
    display: none;
    left: 7% !important;
    right: 7% !important;
    padding: 5px;
    position: absolute;
    bottom: 5% !important;
    background-color: rgba(0, 0, 0, 0) !important;
  }

  .start-button {
    width: auto;
    height: auto;
    border: none;
    border-radius: none;
    background-color: rgba(0, 0, 0, 0);
    cursor: none;
  }

  .button {
    width: 35px;
    border: none !important;
    color: rgba(0, 0, 0, 0) !important;
    background-color: transparent;
  }
}

.video02 {
  position: absolute;
  top: 18.5%;
  margin-left: 5%;
  width: 90.8%;
  z-index: 12;
}

#video02 {
  .vue-video-player-controls {
    max-height: 5px !important;
    display: none;
    left: 7% !important;
    right: 7% !important;
    padding: 5px;
    position: absolute;
    bottom: 5% !important;
    background-color: rgba(0, 0, 0, 0) !important;
  }

  .start-button {
    width: auto;
    height: auto;
    border: none;
    border-radius: none;
    background-color: rgba(0, 0, 0, 0);
    cursor: none;
  }

  .button {
    width: 35px;
    border: none !important;
    color: rgba(0, 0, 0, 0) !important;
    background-color: transparent;
  }
}

.video03 {
  position: absolute;
  top: 13%;
  margin-left: 4%;
  width: 93%;
  height: 53%;
  z-index: 12;
}

#video03 {
  .vue-video-player-controls {
    max-height: 5px !important;
    display: none;
    left: 7% !important;
    right: 7% !important;
    padding: 5px;
    position: absolute;
    bottom: 5% !important;
    background-color: rgba(0, 0, 0, 0) !important;
  }

  .start-button {
    width: auto;
    height: auto;
    border: none;
    border-radius: none;
    background-color: rgba(0, 0, 0, 0);
    cursor: none;
  }

  .button {
    width: 35px;
    border: none !important;
    color: rgba(0, 0, 0, 0) !important;
    background-color: transparent;
  }
}

.video-content {
	.embed-responsive {
    position: absolute;
    z-index: 1000;
    width: 72%;
    height: 67%;
    top: 4.7%;
    left: 14%;
	}
}

.start-button {
  width: auto;
  height: auto;
  border: none !important;
  background-color: rgba(0, 0, 0, 0) !important;
  color: rgba(255, 255, 255, 0.6) !important;
  cursor: pointer;
  margin-top: 100px;
}

.vue-video-player-controls {
  max-height: 5px;
  display: flex;
  left: 7% !important;
  right: 7% !important;
  padding: 5px;
  position: absolute;
  bottom: 14% !important;
  background-color: rgba(0, 0, 0, 0) !important;
}


.vue-player-time-control {
  position: absolute;
  top: -5px;
  left: 0;
  padding-top: 0;
  color: rgba(255, 255, 255, 0.3) !important;
  display: block;
}


.button {
  width: 35px;
  border: none !important;
  color: rgba(255, 255, 255, 0.6) !important;
  background-color: transparent;
}

.minilinksblack {
  position: absolute;
  cursor: pointer;
  color: black;
  font-family: 'lemon_milkregular';
  font-style: italic;
  -webkit-font-smoothing: antialiased;
  font-size: 0.8em;
  z-index: 100;
  text-decoration: underline;
}
</style>
